import {cloneDeep, debounce, throttle, isEqual, uniqWith} from "lodash-es";
import ARTC from './agoraRTC';
import WRTC from './windowRTC';
import ERTC from './electronRTC';
import HTTP from '../script/service';
import Util from '../script/util';
import store from './store';
import { message, Modal } from 'antd';
import {
  _dssp_send_click,
  _anly_seng_custom,
  _show_login_modal,
  _get_user_info,
  _change_phone_modal,
  _emit_call,
  _show_browser_warn,
  _set_store_roomid,
} from './Action';
import AgoraElectronRTC from './RTC/agoraElectronRTC';
import ZegoWebRTC from './RTC/zegoWebRTC';
import ZegoElectronRTC from './RTC/zegoElectronRTC';
import {
  CAMP_ENUM,
  setGameInteractCamp,
} from '../views/room/rmode/gameInteract/util/gameInteractUpmic';
import WEBIM from '../store/WebNim';

const WILL_RECONNECT_DELAY_TIME = 2000; // 重连间隔时长
let MAX_RECONNECT_COUNT = 15; // 最大重连次数

const SDK = window.SDK;
const WEBROOM = (window,
function () {
  const that = {
    roomid: null, //房间id
    roomInfo: null, //直播间消息
    conn: null, //链接状态
    me: null, //个人资料
    volume: 1, //音量
    onlineMembers: {}, //在线成员列表
    onlineMemberCount: 0, //在线成员数量
    members: {}, //成员
    defaultMsg: [], //普通消息队列
    queueList: [], //互动队列列表
    queueObject: {}, //互动队列集合
    liveConfig: null, //互动直播配置
    datingData: null, //相亲数据
    heartbeatData: null, //心动池数据
    events: {}, //事件列表
    magics: [], //魔法表情
    shieldMove: {}, //高级动画屏蔽
    confirmPwd: false, //是否有密码验证
    anomalySpeakUsers: {}, //异常卡麦成员
    publicParams: {},
    isInRoom: false, // 当前是否在房间内
    isAnonymousRoom: false, // 当前是否在房间内
    isReconnect: false, // 是否正在重连
  };
  //事件配置
  that.onConfigFn = function (key, fn) {
    that.events[key] = fn;
  };
  //事件清除
  that.onDeleteEvent = function (key, fn) {
    delete that.events[key];
  };
  //开始连接
  that.openConn = async function (param) {
    const { rootConfig } = that.getBase();
    that.roomid = window.roomid = param.roomid;
    _set_store_roomid(that.roomid);
    that.address = param.address;
    that.uid = param.uid;
    that.account = param.account;
    that.token = param.token;
    // that.point = param.point || {};
    that.gifs = param.gifs;
    that.gifsArray = param.gifsArray;
    that.magics = param.magics;
    that.baseRoomInfo = param.baseRoomInfo;
    that.onlineMembers = {};
    that.onlineMemberCount = 0;
    that.members = {};
    that.defaultMsg = [];
    that.queueList = [];
    that.queueObject = {};
    that.queueLine = [];
    that.volume = 1;
    that.roomInfo = null;
    that.me = null;
    that.liveConfig = null;
    that.datingData = null;
    that.heartbeatData = null;
    that.shieldMove = param.shieldMove;
    that.confirmPwd = false;
    that.anomalySpeakUsers = {};
    that.version = rootConfig.version;
    that.history = param?.history ?? null;
    initLiveConfig();
    connectRoomIM();
  };
  // 链接房间IM
  async function connectRoomIM(joinToken = null) {
    const { rootConfig } = that.getBase();
    if (!that.uid || !that.account || !that.token) {
      /*getAnonymousAccount()
              .then(async () => {
                try {
                  let jionRoomCode = joinToken ? joinToken : await getRoomPreDetail();
                  that.room = SDK.Chatroom.getInstance({
                    debug: false,
                    appKey: rootConfig.NIMKey,
                    account: that.account || null,
                    chatroomNick: setTouristNick(that.account),
                    chatroomAvatar: '',
                    isAnonymous: true,
                    chatroomId: that.roomid,
                    chatroomAddresses: that.address,
                    loginAuthType: 2,
                    token: jionRoomCode,
                    needReconnect: false, // 取消 IM 聊天室自动重连机制
                    onconnect: onChatroomConnect,
                    ondisconnect: onChatroomDisconnect,
                    onmsgs: onmsgs,
                    onwillreconnect: onwillreconnect,
                    onerror: onChatroomError,
                  });
                  _anly_seng_custom(1705, { uid: that.account });
                } catch (err) {
                  message.warning(err?.message ?? "获取房间信息失败，请稍后重试~");
                  if (that?.history) {
                    that.history.push(`/index${window.location.search}`);
                  }
                }
              })
              .catch((error) => {
                message.warning(error.message);
                _anly_seng_custom(1705, { data: error });
                that.events['EXIT_TP_HOME'] && that.events['EXIT_TP_HOME'](true);
              });*/
      // 游客是否在房间的路由里
      that.isAnonymousRoom = true;
      _show_login_modal();
    } else {
      try {
        that.isAnonymousRoom = false;
        let jionRoomCode = joinToken ? joinToken : await getRoomPreDetail();
        that.room = SDK.Chatroom.getInstance({
          debug: false,
          appKey: rootConfig.NIMKey,
          account: that.account,
          token: jionRoomCode,
          loginAuthType: 2,
          chatroomId: that.roomid,
          chatroomAddresses: that.address,
          needReconnect: false, // 取消 IM 聊天室自动重连机制
          onconnect: onChatroomConnect,
          ondisconnect: onChatroomDisconnect,
          onmsgs: onmsgs,
          onwillreconnect: onwillreconnect, // needReconnect = false 不会生效
          onerror: onChatroomError,
        });
      } catch (err) {
        console.error('room init error: ', err);
        _anly_seng_custom(1503, { uid: that.account, data: err });
        message.warning(err?.message ?? '获取房间信息失败，请稍后重试~');
        if (that?.history) {
          that.history.push(`/index${window.location.search}`);
        }
      }
    }

    if (joinToken) {
      _dssp_send_click(87, {
        roomid: that.roomid,
        recoonect: true,
        token: joinToken,
        account: that.account,
        isAnonymous: that.isAnonymous(),
      });
    }
  }
  // 获取 code
  function getRoomPreDetail() {
    return new Promise((resolve, reject) => {
      const params = { roomId: that.roomid };
      if (that.isAnonymous()) {
        params.act = that.account;
      }
      HTTP._get_room_pre_detail(params)
        .then((res) => {
          if (res?.code === 200) {
            store.dispatch({ type: "set_room_microType", data: { microType: res?.data?.microType || 0, sendPic: res?.data?.allowPic || 0 } });
            resolve(res.data.randomToken);
          } else {
            _anly_seng_custom(1502, { data: res }); // 接口数据异常
            reject(res);
          }
        })
        .catch(reject);
    });
  }
  //链接成功
  function onChatroomConnect(obj) {
    console.log('==connect success room==', obj, that.isReconnect);
    console.warn('==connect success address==', that.address);
    that.roomid = obj.chatroom.id;
    window.tempRoomId = null;
    that.recoonectCount = 1;
    that.isInRoom = true;
    const now = Date.now();
    that.createTime = now;
    that.queryOnlineCountTimer = now;
    that.conn = obj;
    that.queueBlockNum = 0; //高频阻断
    that.queueChangeCount = 0; //自解析叠加
    that.queChangeTime = null;
    //存储个人信息
    that.me = convertUserInfo(obj.member, true);
    saveChatRoomInfo(obj.chatroom, async () => {
      //储存个人资料 由于数据丢包现象， 延迟半秒执行
      setTimeout(that.chengMeInfo.bind(this, 'memberEnter'), 500);
      //发送公告
      addDefaultMsg({
        type: 'custom',
        custom: { action: '1-3', text: obj.chatroom.announcement },
      });
      if (
        window?.dicts?.data?.roomWarningMsg &&
        window?.dicts?.data?.roomWarningTime
      ) {
        that.addCustomTimer = setTimeout(() => {
          addDefaultMsg({
            type: 'custom',
            custom: {
              action: '1-3',
              text: window.dicts.data.roomWarningMsg,
              isCustom: true,
            },
          });
        }, window.dicts.data.roomWarningTime * 1000);
      }
      if (!that.isReconnect) {
        //优先清除一次自己的队列，避免异常
        that.queuePoll(that.account);
        //音频初始化
        if (window.eleEvents) {
          if (obj.chatroom.custom.voiceType === 2) {
            console.log('ZEGO_ELECTRON_RTC.openConn');
            if (that.webrtc?.isAgoraRTC) {
              that.webrtc.destroyRoom();
              await Util.sleep(300);
            }
            if (!window.eleEvents?.zgEngine) {
              Util.curVersionIsUpdate(
                true,
                '音质服务已升级，请更新至最新的版本。',
                'rtc-init'
              );
              return;
            }
            store.dispatch({
              type: 'change_rtc_type',
              data: { isAgoraRTC: false },
            });
            that.webrtc = new ZegoElectronRTC(that);
            that.webrtc.openConn(that);
          } else {
            console.log('AGORA_ELECTRON_RTC.openConn');
            if (that.webrtc?.isZegoRTC) {
              that.webrtc.destroyRoom();
              await Util.sleep(300);
            }
            store.dispatch({
              type: 'change_rtc_type',
              data: { isAgoraRTC: true },
            });
            // todo 客户端 316 之后的版本升级了 electron 和 声网的 版本
            if (window.eleEvents?.versionCode > 316) {
              that.webrtc = new AgoraElectronRTC(that);
              that.webrtc.openConn(that);
            } else {
              that.webrtc = ERTC.openConn(that);
            }
          }
        } else if (that.isPC()) {
          if (obj.chatroom.custom.voiceType === 2) {
            Util.curVersionIsUpdate(
              true,
              '音质服务已升级，请更新至最新的版本。',
              'rtc-init'
            );
            return;
          }
          console.log('WRTC.openConn');
          that.webrtc = WRTC.openConn(that);
        } else if (window._ARTC && obj.chatroom.custom.voiceType === 1) {
          console.log('ARTC.openConn');
          store.dispatch({
            type: 'change_rtc_type',
            data: { isAgoraRTC: true },
          });
          that.webrtc = ARTC.openConn(that);
        } else if (obj.chatroom.custom.voiceType === 2) {
          if (window?.WebAssembly) {
            // 需要浏览器支持该方法
            console.log('ZEGO.openConn');
            store.dispatch({
              type: 'change_rtc_type',
              data: { isAgoraRTC: false },
            });
            that.webrtc = ZegoWebRTC.openConn(that);
          } else {
            _show_browser_warn(true);
          }
        } else {
          _show_browser_warn(true);
        }

        store.dispatch({type: "IMROOM_LOAD_COMPLETE", data: {imRoomLoadComplete: true}});
      }
      //初始化队列元素
      getQueueList(null, function () {
        //获取在线成员列表
        getOnlineMembers(() => {
          //触发更新
          changeOnlineMemberCount(0, false, 'initOnlineMembers');
        });
        if (that.roomInfo && that.roomInfo.custom) {
          //跨房PK初始化
          if (that.roomInfo.custom.rmode == 9) {
            that.events['ROOM_PK_CHANGE'] && that.events['ROOM_PK_CHANGE'](that.queueObject.ROOMPK_DATA);
          }
          //房内PK
          else if (that.roomInfo.custom.rmode == 8) {
            that.events['TEAM_PK_CHANGE'] && that.events['TEAM_PK_CHANGE'](that.queueObject.TEAM_PK_DATA);
          }
        }

        store.dispatch({type: "IMROOM_QUEUE_COMPLETE", data: {imRoomQueueComplete: true}});
      });
      that.isReconnect = false; // 重连标识
    });
    if (!that.isAnonymous()) {
      roomEnter();
      //弹幕余额
      that.events['HORN_SUCCESS'] && that.events['HORN_SUCCESS']();
      //获取喇叭、弹幕
      that.events['ROOM_WEALTH_UP'] && that.events['ROOM_WEALTH_UP']();
      //回归礼物数量
      that.events['CHANGE_GIFT_NUMBER'] && that.events['CHANGE_GIFT_NUMBER']();
    }
  }
  //链接中断
  function onChatroomDisconnect(error) {
    const { rootConfig, chatErrCode } = that.getBase();
    if (error && error.code != 'logout') {
      // 退出登录不上报
      _anly_seng_custom(1707, {
        data: {
          code: error.code,
          cmd: error.cmd,
          reason: error.reason,
          retryCount: error.retryCount,
          willReconnect: error.willReconnect,
        },
      });
    }
    console.warn('==onChatroomDisconnect==', error);
    console.log('==address==', that.address);
    //被踢出聊天室
    if (error.code == '13003' && error.cmd == 'login') {
      disconnect();
      that.clearRoomData();
      message.warning('你已被管理拉入房间黑名单', 5);
      that.events['EXIT_TP_HOME'] && that.events['EXIT_TP_HOME'](true);
    }
    // 聊天室初始化异常
    if (error.code == '13002' && error.cmd == 'login') {
      disconnect();
      that.clearRoomData();
      message.warning('当前聊天室状态异常，请重新进入', 5);
      that.events['EXIT_TP_HOME'] && that.events['EXIT_TP_HOME'](true);
    }
    //被踢出聊天室
    else if (error.code == 'kicked' && error.reason == 'managerKick') {
      disconnect();
      that.clearRoomData();
      message.warning('你已被管理踢出直播大厅', 5);
      that.events['EXIT_TP_HOME'] && that.events['EXIT_TP_HOME'](true);
    }
    // 聊天室被关闭
    if (error.code == 'kicked' && error.reason == 'chatroomClosed') {
      disconnect();
      that.clearRoomData();
      message.warning('当前聊天室已被关闭，请重新进入', 5);
      that.events['EXIT_TP_HOME'] && that.events['EXIT_TP_HOME'](true);
    }
    //多端登录
    else if (error.code == 'kicked' && error.reason == 'samePlatformKick') {
      disconnect();
      that.clearRoomData();
      message.warning('不允许同一个帐号在多个地方同时进入同一个直播大厅');
      that.events['EXIT_TP_HOME'] && that.events['EXIT_TP_HOME'](true);
    } else if (error.code == '20015' && error.cmd == 'login') {
      disconnect();
      _anly_seng_custom(1506, { roomid: that.roomid, data: error });
      Modal.info({
        title: '提示',
        icon: null,
        closable: true,
        content: '网络异常无法自动重新链接，请刷新或重启软件',
        className: 'daidai-confirm-style',
        cancelText: '取消',
        okText: '确定',
        centered: true,
        onOk: () => {
          that.clearRoomData();
          window.location.reload(true);
        },
        onCancel: () => {
          that.clearRoomData();
          window.location.reload(true);
        },
      });
    }
    // 异常状态
    else if (rootConfig.roomErrorCode[error.code] != null) {
      disconnect();
      that.clearRoomData();
      message.warning(rootConfig.roomErrorCode[error.code]);
      that.events['EXIT_TP_HOME'] && that.events['EXIT_TP_HOME'](true);
    }
    // 触发重连机制
    else if (
      !error.code &&
      !error.cmd &&
      error.retryCount === 0 &&
      !error.willReconnect
    ) {
      console.warn('==开始重连==');
      // that.room.disconnect(); // 断开聊天室
      that.room.destroy(); // 销毁房间
      that.conn = null;
      that.isReconnect = true;
      // 开始重连
      customWillReconnect();
    }
    // 错误信息在字典中
    else {
      disconnect();
      if (!!chatErrCode) {
        const find = chatErrCode.find((n) => n.code == error.code);
        if (find) {
          message.warning(find.message);
        }
      }
    }
    if (error.code != 'logout') {
      // that.clearRoomData();
      console.error('onChatroomDisconnectonChatroomDisconnect', error);
    }
    if (window.wio) {
      window.wio.emit(
        'chatStatus',
        JSON.stringify({
          status: 0,
          uid: that.uid,
          roomid: that.roomid,
          timestamp: Date.now(),
        })
      );
    }
  }
  //重连机制
  async function onwillreconnect(obj) {
    console.warn('==onwillreconnect room==', obj);
    _anly_seng_custom(1708, { data: obj, isReconnect: that.isReconnect });
    if (!that.isReconnect) {
      that.conn = null;
      //关闭伴奏状态
      that.events['CHANGE_AUDIO_STATE'] &&
        that.events['CHANGE_AUDIO_STATE'](false);
      //下麦标注
      that.events['CHANGE_UPINMIC_STATE'] &&
        that.events['CHANGE_UPINMIC_STATE'](false);
      //清除互动直播
      that.webrtc && that.webrtc.destroyRoom(1);
    }
    // 重连次数上报
    if (obj?.retryCount && obj?.custom) {
      _dssp_send_click(88, { roomid: that.roomid, data: obj });
    }
  }
  // 自定义重连机制
  async function customWillReconnect() {
    that.recoonectTimer && clearTimeout(that.recoonectTimer);
    if (that.recoonectCount > MAX_RECONNECT_COUNT) {
      disconnect();
      // 超过重连次数
      Modal.info({
        title: '提示',
        icon: null,
        closable: true,
        content: '网络异常无法自动重新链接，请检查网络是否正常',
        className: 'daidai-confirm-style',
        cancelText: '取消',
        okText: '确定',
        centered: true,
        onOk: () => {
          that.clearRoomData();
          window.location.reload(true);
        },
        onCancel: () => {
          that.clearRoomData();
          window.location.reload(true);
        },
      });
      return;
    }
    that.recoonectTimer = setTimeout(() => {
      onwillreconnect({
        retryCount: that.recoonectCount,
        duration: WILL_RECONNECT_DELAY_TIME,
        custom: true,
      });
      getRoomPreDetail()
        .then((res) => {
          connectRoomIM(res); // 重连
          clearTimeout(that.recoonectTimer);
          // 发起重连
          _anly_seng_custom(1505, {
            roomid: that.roomid,
            data: {
              recoonect: true,
              token: res,
              isAnonymous: that.isAnonymous(),
              address: that.address,
            },
          });
        })
        .catch((err) => {
          console.error('==will reconnect error==', err);
          // 获取信息失败上报
          _anly_seng_custom(1504, {
            uid: that.account,
            data: err,
            address: that.address,
          });
          // 获取失败，重新获取，直到获取成功
          that.recoonectCount = that.recoonectCount + 1;
          customWillReconnect();
        });
    }, WILL_RECONNECT_DELAY_TIME);
  }
  //链接异常
  function onChatroomError(error) {
    // 此处异常无需处理，此时会触发重连机制
    console.error('====onChatroomError====', error);
    // message.warning("链接异常，正在重连中。。。")
    // that.clearRoomData();
    _anly_seng_custom(1701, { data: error, address: that.address });
  }
  //退出直播间
  function disconnect() {
    //上报
    _dssp_send_click(74, {
      uid: that.uid,
      room_id: that.roomid,
      event_timestamp: Date.now(),
    });
    //清除连接状态
    that.conn = null;
    clearTimeout(that.anonymous_time);
    //1、清除互动直播
    that.webrtc && that.webrtc.destroyRoom(2);
    //2、数据还原
    that.reloadExec();
    that.isReconnect = false; // 重连标识

    if (getChatRoomOnlineNum?.cancel) {
      getChatRoomOnlineNum.cancel();
    }

    _set_store_roomid(null); // 退出房间清除房间 ID

    store.dispatch({type: "IMROOM_LOAD_COMPLETE", data: {imRoomLoadComplete: false}});
    store.dispatch({type: "IMROOM_QUEUE_COMPLETE", data: {imRoomQueueComplete: false}});
  }
  //批量消息
  function onmsgs(msgs) {
    if (window.dbgType || process.env.CLIENT_ENV === 'development') {
      if (!window.glroom) window.glroom = that;
      if (!window.glroot) window.glroot = WEBIM;
      console.log('new msgs =>', msgs);
    }
    const len = msgs.length;
    msgs.forEach((msg, index) => {
      onmsg(msg, index, len);
    });
  }
  //消息处理
  function onmsg(msg, index, len = 1) {
    try {
      if (msg.type === 'notification') {
        //游客进入直播间
        if (msg.attach.type === 'memberEnter') {
          let iswp = msg.from.indexOf('wp_') !== -1;
          let isnon = msg.from.indexOf('nimanon_') !== -1;
          if (iswp || isnon) {
            let user = convertUserInfo(msg);
            if (isnon) {
              //清空游客头像
              msg.avatar = '';
              msg.user = { ...user };
              addDefaultMsg(msg);
            }

            // todo IOS重连不会触发 updateMemberInfo 事件，但又由于正常进入房间会触发此消息，且同时会触发 updateMemberInfo，所以采用延迟的方案解决IOS重连列表没有更新的问题
            if (!that.memberEnterTimer) that.memberEnterTimer = {};
            if (!!msg.from) {
              that.memberEnterTimer[msg.from] = setTimeout(() => {
                if (iswp && !that?.onlineMembers?.[msg.from]) {
                  that.joinOnlineMember(msg.from, user, null, 'memberEnter');
                }
              }, 3000);
            }
          } else {
            console.warn('异常用户进入', msg);
            _anly_seng_custom(1706, { data: msg });
          }
        }
        //离开聊天室
        else if (msg.attach.type == 'memberExit') {
          that.delOnlineMember(msg.attach.to[0]);
        }
        //更新用户资料
        else if (msg.attach.type == 'updateMemberInfo') {
          updateMemberMsg(msg);

          // 更新房间角色
          if (msg.attach?.custom === "updateMyRoomRole") {
            const user = that.members[msg.from];
            // 在成员列表，则更新
            if (user) {
              that.events['CHANGE_MEMBER_INFO'] && that.events['CHANGE_MEMBER_INFO'](that.onlineMembers);
            }
          }

          if (msg?.from && that?.memberEnterTimer?.[msg.from]) {
            clearTimeout(that.memberEnterTimer[msg.from]);
          }
        }
        //房间资料更新
        else if (
          msg?.attach?.type == 'updateChatroom' &&
          msg?.attach?.custom.indexOf('roomChange') != -1
        ) {
          //开黑房间类型切换
          let categoryId = 0;
          let roomRmode = 0;
          if (
            that.roomInfo &&
            that.roomInfo.custom &&
            that.roomInfo.custom.blackTeamRoomInfo
          ) {
            categoryId = that.roomInfo.custom.blackTeamRoomInfo.categoryId;
          }
          if (that.roomInfo && that.roomInfo.custom) {
            roomRmode = that.roomInfo.custom.rmode;
          }
          getChatRoomInfo(function () {
            let categoryId_new = 0;
            let roomRmode_new = 0;
            if (
              that.roomInfo &&
              that.roomInfo.custom &&
              that.roomInfo.custom.blackTeamRoomInfo
            ) {
              categoryId_new =
                that.roomInfo.custom.blackTeamRoomInfo.categoryId;
            }
            if (that.roomInfo && that.roomInfo.custom) {
              roomRmode_new = that.roomInfo.custom.rmode;
            }
            if (categoryId && categoryId != categoryId_new) {
              that.events['CHANGE_LIVE_CONFIG'] &&
                that.events['CHANGE_LIVE_CONFIG']({
                  action: 'memberSKCardAll',
                });
            }
            //开始执行房间模板变更 - 跨房PK
            if (roomRmode != roomRmode_new && roomRmode_new == 9) {
              if (that.isMaster()) {
                that.queueList.forEach((queue) => {
                  if (queue.index != 0) {
                    that.queuePoll(queue.account);
                  }
                });
              }
            }
            //跨房PK PK模板不允许神豪位存在
            if (roomRmode_new == 9 || roomRmode_new == 8) {
              if (that.isMaster()) {
                that.queueList.forEach((queue) => {
                  if (queue.index == 9) {
                    that.queuePoll(queue.account);
                  }
                });
              }
            }
            //房间模板变更通知
            if (roomRmode != roomRmode_new) {
              addDefaultMsg({
                type: 'custom',
                custom: {
                  action: 'RMODE_CHANGE',
                  oldRmode: roomRmode,
                  newRmode: roomRmode_new,
                },
              });
            }
            //当房间信息变更时 强制获取一次队列
            setTimeout(getQueueList, 1000);
          });
        }
        //队列更新
        else if (
          msg.attach.type == 'updateQueue' ||
          msg.attach.type == 'batchUpdateQueue' ||
          msg.attach.type == 'batchQueueOffer'
        ) {
          let queue = msg.attach.queueChange;
          let type = queue.type;
          let elementKey = queue.elementKey;
          let elementValue = queue.elementValue;
          let elementKeys = [];
          let elementObjct = {};
          let userAccounts = [];
          //APP属性不同
          if (queue.elementKv) {
            for (let i in queue.elementKv) {
              elementKey = i;
              elementValue = queue.elementKv[i];
              elementKeys.push(elementKey);
              elementObjct[elementKey] = elementValue;
            }
          }
          if (elementValue && typeof elementValue == 'string') {
            try {
              elementValue = JSON.parse(elementValue);
            } catch (error) {
              console.error('队列解析错误：', error, msg);
            }
          }
          let key = elementKey;
          that.queueChangeCount += 1;
          //多队列变更时, 每500次队列变更
          if (elementKeys.length > 1 || that.queueChangeCount >= 500) {
            getQueueList();
          }
          //添加 || 更新
          else if (type == 'OFFER') {
            let oldValue = null;
            if (that.queueObject?.[elementKey]) {
              oldValue = that.queueObject[elementKey];
            }
            that.queueObject[elementKey] = { ...elementValue };
            //麦位变更
            if (elementKey && elementKey.indexOf('wp_') != -1) {
              let index = that.queueList.findIndex(function (value) {
                return elementValue.account == value.account;
              });
              if (index != -1) {
                that.queueList[index] = elementValue;
              } else {
                that.queueList.push(elementValue);
              }
              if (!that.members[elementValue.account]) {
                userAccounts.push(elementValue.account);
              }
              // 我切换麦位同步之前的状态 todo 2025.02.10
              if (
                elementKey === that?.me?.account &&
                oldValue?.index !== elementValue?.index
              ) {
                const { microType, isMasterDisAudio } = that.getBase();
                let isSync = microType === 0;
                // 切换麦位同步之前的麦位麦克风状态
                if (!oldValue?.disAudio) {
                  isSync = true;
                }
                changeMeMicState({
                  disAudio:
                    oldValue?.disAudio ?? elementValue?.disAudio ?? true,
                  isChangeIndex: true,
                  isSync,
                  isMasterDisAudio,
                });
              }
              key = 'LIVE_MEMBER_CHANGE';
            }
            //排麦变更
            else if (elementKey && elementKey.indexOf('queue_') != -1) {
              let index = that.queueLine.findIndex(function (value) {
                return elementValue.account == value.account;
              });
              if (index != -1) {
                that.queueLine[index] = elementValue;
              } else {
                that.queueLine.push(elementValue);
              }
              if (!that.members[elementValue.account]) {
                userAccounts.push(elementValue.account);
              }
              //我在线之后， 又重新更新排麦队列 = 换位置
              if (elementKey == `queue_${that.uid}`) {
                if (elementValue && elementValue.state == 1) {
                  if (that.hasQueume()) {
                    //麦上移位
                    that.onUpmicRTC(elementValue.index);
                  } else {
                    //同意上麦、邀请上麦
                    that.events['CHANGE_LIVEON_MIC'] &&
                      that.events['CHANGE_LIVEON_MIC'](elementValue);
                  }
                } else if (elementValue && elementValue.state == 2) {
                  //多写一步 删除
                  that.queuePoll(`queue_${that.uid}`);
                  message.info('主持人已拒绝你的申请');
                }
              }
            }
            //直播配置变更
            else if (elementKey == 'MIC_CONFIG_DATA') {
              that.liveConfig = elementValue;
            }
            //相亲数据变更
            else if (elementKey == 'DATING_DATA') {
              let state = 0;
              if (that.datingData && that.datingData.sdata)
                state = that.datingData.sdata.state;
              that.datingData = elementValue;
              var new_state = 0;
              if (elementValue && elementValue.sdata)
                new_state = elementValue.sdata.state;
              //公布结果
              if (state == 2 && new_state == 3) {
                //先确保用户信息完整性
                const accounts = [];
                const cps = [];
                const { sdata: { data = {}, selected = {} } = {}, pair = [] } =
                  that.datingData;
                for (let i in selected) {
                  accounts.push(Util.$analyToAccount(i));
                }
                that.getMembersInfo(accounts, function (members) {
                  pair.forEach((par) => {
                    let user1 = that.members[Util.$analyToAccount(par.uid)];
                    let user2 = that.members[Util.$analyToAccount(par.cpUid)];
                    let cp1 = data[par.uid];
                    let cp2 = data[par.cpUid];
                    let total = 0;
                    if (cp1 && cp2) {
                      total = cp1.heart + cp2.heart;
                    }
                    cps.push({
                      pair: par,
                      ctime: Date.now(),
                      grade: par.grade,
                      avatar1: user1.avatar,
                      nickname1: user1.nick,
                      avatar2: user2.avatar,
                      nickname2: user2.nick,
                      roomid: that.roomid,
                      total: total,
                      u1: par.uid,
                      u2: par.cpUid,
                    });
                  });
                  that.events['START_DATING_MOVE'] &&
                    that.events['START_DATING_MOVE'](cps);
                  that.events['ROOM_ORDER_CHANGE'] &&
                    that.events['ROOM_ORDER_CHANGE'](3);
                });
              }
            }
            //心动池数据变更
            else if (elementKey == 'HEARTBEAT_DATA') {
              that.heartbeatData = elementValue;
            }
            //麦位倒计时
            else if (elementKey == 'POSITION_TIMER') {
              that.positionTime = elementValue.sdata || [];
            }
            //神豪位
            else if (elementKey == 'GAD_HOWE') {
              that.godHowe = elementValue.sdata || null;
            }
            //跨房PK
            else if (elementKey == 'ROOMPK_DATA') {
              that.roomPK = elementValue;
            }
            //房内PK
            else if (elementKey == 'TEAM_PK_DATA') {
              that.teamPK = elementValue;
            }
            //派单信息
            else if (elementKey == 'ROOM_DISPATCH_ORDER_ACTION') {
              that.sendOrders = elementValue;
            }
            // 点唱房正在演唱
            else if (elementKey == 'playingSong') {
              that.events['CLICK_MUSIC_CHANGE_ING'] &&
                that.events['CLICK_MUSIC_CHANGE_ING'](true, elementValue);
            }
            // 点唱房待唱数据变更
            else if (elementKey == 'chooseSongChange') {
              that.events['CLICK_MUSIC_CHANGE_LIST'] &&
                that.events['CLICK_MUSIC_CHANGE_LIST']();

              if (that?.roomInfo?.custom?.rmode === 36) {
                that.events['CLICK_MUSIC_LIST_UPDATE'] &&
                  that.events['CLICK_MUSIC_LIST_UPDATE']();
              }
            }
            // 互动游戏数据变更
            else if (elementKey == 'INTERACTIVE_GAME_DATA') {
              that.gameInteractData = elementValue;
            }
            // 第三方游戏数据变更
            else if (elementKey == 'MINE_GAME_KEY_7eb32fc5be54') {
              that.gameOtherMicData = elementValue;
            }
            // 麦位礼物长动效
            else if (elementKey == 'GIFT_MICROPHONE_SLOT_EFFECTS') {
              // 合并新老数据，为了移除和新增定时器
              const newItems = [
                ...(that?.micLongEffectData || []),
                ...(elementValue?.items || []),
              ];
              that.micLongEffectData = uniqWith(newItems, isEqual);
              that.micLongEffectData.forEach((item) => {
                that.events[`GIFT_MICROPHONE_SLOT_EFFECTS_${item.uid}`] &&
                  that.events[`GIFT_MICROPHONE_SLOT_EFFECTS_${item.uid}`]();
              });
            }
            // 麦位连线
            else if (elementKey == 'INTIMATE_MICROPHONE_SLOT_CONNECTION') {
              that.events[`INTIMATE_MICROPHONE_SLOT_CONNECTION`] &&
                that.events[`INTIMATE_MICROPHONE_SLOT_CONNECTION`](
                  elementValue
                );
            }
            // 麦位投屏 - 主房间
            else if (elementKey === "MAIN_ROOM_MIC_IMAGE") {
              that.events?.["MAIN_ROOM_MIC_IMAGE"]?.(elementValue);
            }
            // 麦位投屏 - 副房间
            else if (elementKey === "SUB_ROOM_MIC_IMAGE") {
              that?.events?.["SUB_ROOM_MIC_IMAGE_CHANGE"]?.(elementValue);
            }
            else {
              if (elementKey === "NDHD_ROOM_LUCKY_BAG_2024" || elementKey === "NDSD_ROOM_DDX_2024" || elementKey === "NDSD_ROOM_ZLX_2024" ) {
                // 年度活动队列不打印 console
              } else {
                console.log('非常规队列变更:', queue);
              }
            }
            //变更 执行对应事件
            if (userAccounts.length > 0) {
              that.getMembersInfo(userAccounts, () => {
                queueEventChange(key);
              });
            } else {
              queueEventChange(key);
            }
            //如果是我自己的队列
            if (elementKey.indexOf(that.uid) > -1) {
              console.warn('更新', elementKey, msg);
            }
          }
          //移除 || 清除
          else if (type == 'POLL' || type == 'PARTCLEAR') {
            //麦位变更
            if (elementKey && elementKey.indexOf('wp_') != -1) {
              delete that.queueObject[elementKey];
              let index = that.queueList.findIndex(function (value) {
                return elementValue.account == value.account;
              });
              if (index != -1) {
                that.queueList.splice(index, 1);
              }
              if (!that.members[elementValue.account]) {
                userAccounts.push(elementValue.account);
              }
              if (elementKey === that?.me?.account) {
                store.dispatch({
                  type: 'set_is_master_dis_audio',
                  data: { isMasterDisAudio: false, isSelfDisAudio: false },
                });
              }
              key = 'LIVE_MEMBER_CHANGE';
            }
            //排麦变更
            else if (elementKey && elementKey.indexOf('queue_') != -1) {
              delete that.queueObject[elementKey];
              let index = that.queueLine.findIndex(function (value) {
                return elementValue.account == value.account;
              });
              if (index != -1) {
                that.queueLine.splice(index, 1);
              }
              if (!that.members[elementValue.account]) {
                userAccounts.push(elementValue.account);
              }
              key = 'QUEUE_MEMBER_CHANGE';
            }
            //直播配置变更
            else if (elementKey == 'MIC_CONFIG_DATA') {
              initLiveConfig(); //还原初始化 此场景不存在，存在即异常
            }
            //相亲数据变更
            else if (elementKey == 'DATING_DATA') {
              that.datingData = null;
            }
            //心动池数据变更
            else if (elementKey == 'HEARTBEAT_DATA') {
              that.heartbeatData = null;
            }
            //麦位倒计时
            else if (elementKey == 'POSITION_TIMER') {
              that.positionTime = [];
            }
            //神豪位
            else if (elementKey == 'GAD_HOWE') {
              that.godHowe = null;
            }
            //跨房PK
            else if (elementKey == 'ROOMPK_DATA') {
              that.roomPK = null;
            }
            //派单信息
            else if (elementKey == 'ROOM_DISPATCH_ORDER_ACTION') {
              that.sendOrders = null;
            }
            // 移除正在演唱的歌曲
            else if (elementKey == 'playingSong') {
              delete that.queueObject[elementKey];
              that.events['CLICK_MUSIC_CHANGE_ING'] &&
                that.events['CLICK_MUSIC_CHANGE_ING'](false, elementValue);
            }
            // 互动游戏数据变更
            else if (elementKey == 'INTERACTIVE_GAME_DATA') {
              that.gameInteractData = null;
            }
            // 第三方游戏数据变更
            else if (elementKey == 'MINE_GAME_KEY_7eb32fc5be54') {
              that.gameOtherMicData = null;
            }
            // 麦位投屏 - 主房间
            else if (elementKey === "MAIN_ROOM_MIC_IMAGE") {
              that.events?.["MAIN_ROOM_MIC_IMAGE"]?.();
            }
            // 麦位投屏 - 副房间
            else if (elementKey === "SUB_ROOM_MIC_IMAGE") {
              that?.events?.["SUB_ROOM_MIC_IMAGE_DELETE"]?.(elementValue);
            } else {
              console.log('非常规队列移除:', queue);
            }
            //变更 执行对应事件
            if (userAccounts.length > 0) {
              that.getMembersInfo(userAccounts, () => {
                queueEventChange(key);
              });
            } else {
              queueEventChange(key);
            }
            //如果是我自己的队列
            if (elementKey.indexOf(that.uid) > -1) {
              console.warn('移除', elementKey, msg);
            }
          }
          //多队列变更 整体执行查询更新
          else {
            console.warn('未识别队列变更类型', msg);
            getQueueList(key);
          }
        }
        //踢出聊天室
        else if (msg.attach.type == 'kickMember') {
          that.delOnlineMember(msg.attach.to[0]);
          addDefaultMsg({
            ...msg,
            user: { ...that.members[msg.attach.to[0]] },
          });
        }
        //加入黑名单
        else if (msg.attach.type == 'blackMember') {
          that.delOnlineMember(msg.attach.to[0]);
          addDefaultMsg({
            ...msg,
            user: { ...that.members[msg.attach.to[0]] },
          });
        }
        //公共处理 [禁言/解除禁言/设为管理/取消管理]
        else if (
          msg.attach.type == 'addTempMute' ||
          msg.attach.type == 'removeTempMute' ||
          msg.attach.type == 'gagMember' ||
          msg.attach.type == 'ungagMember' ||
          msg.attach.type == 'addManager' ||
          msg.attach.type == 'removeManager' ||
          msg.attach.type == 'unblackMember'
        ) {
          const user = that.members?.[msg.attach.to[0]] || {};
          if (user?.nick == null) {
            user.account = msg.attach.to[0];
            user.nick = msg.attach.toNick[0];
          }
          msg.user = { ...user };
          addDefaultMsg(msg);
        }
      } else if (msg.type == 'text') {
        const user = convertUserInfo(msg); // todo 2025.07.18 优先获取IM消息中的用户信息
        if (user?.custom?.is_default_custom) {
          that.getMemberInfo(msg.from, false, "文本消息").then((user) => {
            if (msg.text) msg.text = msg.text.replace(/<|iframe|alert|javascript|marquee|console|confirm/g, '*');
            msg.user = { ...user };
            addDefaultMsg(msg);
          });
        } else {
          if (msg.text)
            msg.text = msg.text.replace(
              /<|iframe|alert|javascript|marquee|console|confirm/g,
              '*'
            );
          msg.user = { ...user };
          addDefaultMsg(msg);
        }
      } else if (msg.type == 'custom') {
        let custom = {};
        if (msg.content && msg.content != '') {
          custom = JSON.parse(msg.content);
        } else if (msg.custom && msg.custom != '') {
          custom = JSON.parse(msg.custom);
        }
        if (!custom.action) return false;
        msg.custom = custom;
        if (custom.action == '0-0') {
          addDefaultMsg(msg);
        }
        //直播开启 直播被停止  发送公告
        else if (
          custom.action == '1-1' ||
          custom.action == '1-2' ||
          custom.action == '1-3'
        ) {
          const user = convertUserInfo(msg);
          msg.user = { ...user };
          addDefaultMsg(msg)
        }
        //送礼物
        else if (custom.action == '2-1') {
          const user = msg.from ? that.members[msg.from] : null;
          user && (msg.user = { ...user });
          if (Array.isArray(custom.toExt) == false) {
            custom.toExt = [custom.toExt];
          }
          // todo 互动游戏模板且在游戏中不展示礼物特效，横幅
          const isInteractGame = that?.roomInfo?.custom?.rmode === 4 && that.gameInteractData?.pkStatus === 1;
          //普通礼物
          if (!that.shieldMove.DisGiftMove && !isInteractGame) {
            // 礼物套装
            if (custom.showListEffect === 1 && custom.giftList?.length) {
              custom.giftList.forEach((n, i) => {
                let gift_url = n.pcEffect || n.giftIcon;
                if (gift_url.indexOf(".mp4") > -1 || gift_url.indexOf(".svga") > -1) {
                  that.events['START_GIFT_USPER_MOVE'] && that.events['START_GIFT_USPER_MOVE']({ ...custom, app_voice: n?.app_voice || null, gift_url });
                } else {
                  let static_pic = n.pcEffect || n.giftIcon;
                  window.giftEffectTimer = setTimeout(() => {
                    that.events['START_GIFT_MOVE'] && that.events['START_GIFT_MOVE']({ ...msg, custom: { ...custom, static_pic } });
                  }, i * 500);
                }
              })
            } else if (custom.pcSvg || custom.pcMp4) {
              custom.gift_url = custom.pcSvg || custom.pcMp4;
              that.events['START_GIFT_USPER_MOVE'] && that.events['START_GIFT_USPER_MOVE'](custom);
            } else {
              if (len > 1) {
                window.giftEffectTimer = setTimeout(() => {
                  that.events['START_GIFT_MOVE'] && that.events['START_GIFT_MOVE'](msg);
                }, index * 100);
              } else {
                that.events['START_GIFT_MOVE'] && that.events['START_GIFT_MOVE'](msg);
              }
            }
          }
          if (msg && msg.custom.mic_gif) {
            let users = [];
            if (custom?.micEffectAll === 1) {
              // 全麦
              for (const key in that.queueObject) {
                if (key.indexOf('wp_') !== -1 && that.hasQueume(key)) {
                  users.push(key);
                }
              }
            } else {
              // 非全麦
              if  (custom?.to?.length) {
                users = custom?.to;
              }
            }
            users.forEach(item => {
              const account = item;
              const eventKey = `MIC_GIFT_EFFECT_${account}`;
              // 我自己亲密关系的麦位动效
              custom?.mic_gif && that.events[eventKey] && that.events[eventKey]({
                account,
                mic_gif: custom.mic_gif,
                name: account,
                delay: custom.mic_gif_frame_count * 1000,
                origin: "send_gift",
              })
            })
          }
          //过滤送箱子消息 公屏消息
          if (!custom.box_num) {
            addDefaultMsg(msg);
          }
        }
        //获得礼物
        else if (custom.action == '2-2') {
          if (
            custom.type == 99 &&
            Util.$analyToAccount(custom.uid) == that.me.account
          ) {
            _emit_call({ name: 'show_wish_award', payload: custom });
            if (custom.gift_type == 1) {
              //更新喇叭数量
              _emit_call({ name: 'update_trumpet' });
            }
          }
          addDefaultMsg(msg);
        }
        //送礼物:2-3 相亲成功:6-1 开瓶子:80-1 送瓶子:80-4, 删除（领红包:12-2 获得靓号:20-5） 99-1(统一横幅)
        else if (
          custom.action == '2-3' ||
          custom.action == '6-1' ||
          custom.action == '80-1' ||
          custom.action == '80-4' ||
          custom.action == '99-1'
        ) {
          // 检测是否屏蔽动画
          if (!that.shieldMove.DisRoomStreamer) {
            if (custom.actionBody && Array.isArray(custom.actionBody)) {
              custom.actionBody.forEach((con) => {
                if (con.body && con.content) {
                  that.events['CHANGE_TOP_MESSAGE'] &&
                    that.events['CHANGE_TOP_MESSAGE'](con);
                }
              });
            }
          }
        }
        //直播间财富升级
        else if (custom.action == '2-8') {
          const levelInfo = custom.fromExt.wealthLevel.split('_');
          const maxLevel = levelInfo[0];
          let isAll = false;
          //侯爵以上全站广播
          if (Number(maxLevel) > 6) {
            isAll = true;
          }
          that.events['ROOM_MEMBER_WEALTH_UP'] &&
            that.events['ROOM_MEMBER_WEALTH_UP']({ ...custom, isAll });
        }
        //直播间贵族升级
        else if (custom.action == 'USER_NOBLE_LEVEL_UP') {
          let isAll = false;
          //海皇以上全站广播
          if (custom.nobleLevel != null && Number(custom.nobleLevel) > 2) {
            isAll = true;
          }
          that.events['USER_NOBLE_LEVEL_UP'] &&
            that.events['USER_NOBLE_LEVEL_UP']({ ...custom, isAll });
        }
        //指定麦上人员发送表情
        else if (custom.action == '2-4') {
          if (msg.fromClientType == 'Server' || msg.fromClientType == 'REST') {
            custom.to.forEach((item, index) => {
              let dom = document.querySelector(`.mic-cover.${item}`);
              let gif = [];
              if (custom.emoji_id == 'shouzhang') {
                gif = [
                  {
                    id: 'shouzhang',
                    name: '猜拳',
                    pic: '/assets/img/shouzhang_static.png',
                  },
                ];
              } else if (custom.emoji_id == 'shaizi') {
                gif = [
                  {
                    id: 'shaizi',
                    name: '骰子',
                    pic: '/assets/img/shaizi_static.png',
                  },
                ];
              } else if (custom.emoji_id == 'maxshaizi') {
                gif = [
                  {
                    id: 'maxshaizi',
                    name: '大骰子',
                    pic: '/assets/img/maxshaizi_static.png',
                  },
                ];
              } else if (custom.emoji_id == 'gold') {
                gif = [
                  {
                    id: 'gold',
                    name: '掷金币',
                    pic: '/assets/img/gold_static.png',
                  },
                ];
              } else if (that.magics && that.magics.filter) {
                gif = that.magics.filter((item) => item.id == custom.emoji_id);
              }
              if (dom && gif.length > 0) {
                bindGiftEmoji(dom, gif[0], custom.shaizi_num[index]);
              }
            });
          } else {
            console.warn('非正常消息指令：', msg);
          }
        }
        //直播间VIP升级
        else if (custom.action == '2-7') {
          // todo 互动游戏模板且在游戏中不展示礼物特效，横幅
          const isInteractGame =
            that?.roomInfo?.custom?.rmode === 4 &&
            that.gameInteractData?.pkStatus === 1;
          //是否屏蔽动画
          if (!that.shieldMove.DisUpdateBroadcast && !isInteractGame) {
            //升级通知
            that.events['ROOM_MEMBER_VIP_UP'] &&
              that.events['ROOM_MEMBER_VIP_UP'](custom);
          }
          //刷新列表 - 关闭VIP自动刷新
          that.events['CHENG_ROOM_VIPS'] &&
            that.events['CHENG_ROOM_VIPS'](that.roomid);
        }
        //贵族上线
        else if (custom.action == 'NOBLE_LOGIN') {
          that.events['ROOM_NOBLE_LOGIN'] &&
            that.events['ROOM_NOBLE_LOGIN'](custom);
        }
        //被踢下麦
        else if (custom.action == '3-2') {
          const user = that.members?.[custom.account] || null;
          if (user) {
            msg.user = { ...user };
            addDefaultMsg(msg);
          } else {
            that.getMemberInfo(custom.account, false, '被踢下麦').then((user) => {
              msg.user = {...user};
              addDefaultMsg(msg);
            });
          }
        }
        //房间魅力排行榜更新
        else if (custom.action == '4-2') {
          that.events['ROOM_ORDER_CHANGE'] &&
            that.events['ROOM_ORDER_CHANGE'](2);
        }
        //房间财富排行榜更新
        else if (custom.action == '4-3') {
          that.events['ROOM_ORDER_CHANGE'] &&
            that.events['ROOM_ORDER_CHANGE'](1);
        }
        //麦为静音
        else if (custom.action == '5-2') {
          // 如果这个人是我
          if (custom.account == that.me.account) {
            const {
              isSelfDisAudio: yxIsSelfDisAudio,
              isMasterDisAudio: yxIsMasterDisAudio,
              disAudio,
              isSync,
            } = custom;
            const { isMasterDisAudio, isSelfDisAudio } = that.getBase();

            if (
              (yxIsMasterDisAudio && isSelfDisAudio) || // 主持人闭麦自行无法解开麦克风
              (yxIsSelfDisAudio && isMasterDisAudio) // 自行闭麦主持人无法解开麦克风
            ) {
            } else {
              store.dispatch({
                type: 'set_is_master_dis_audio',
                data: {
                  isMasterDisAudio: !!(disAudio && yxIsMasterDisAudio),
                  isSelfDisAudio: !!(disAudio && yxIsSelfDisAudio),
                },
              });
              changeMeMicState({ disAudio, isSync });
            }
          }
        }
        //弹幕消息
        else if (custom.action == '7-1') {
          that.getMemberInfo(msg.from, false, '弹幕消息').then((user) => {
            msg.custom = { ...custom };
            msg.user = { ...user };

            // todo 2024.12.16 互动游戏跨房PK中不展示弹幕
            const isInteractGame =
              that?.roomInfo?.custom?.rmode === 4 &&
              that.gameInteractData?.pkStatus === 1 &&
              that.gameInteractData?.playType === 2;
            //是否屏蔽弹幕
            if (!that.shieldMove.DisRoomBullet && !isInteractGame) {
              that.events['SHOW_BARRAGE'] && that.events['SHOW_BARRAGE'](msg);
            }
            that.events['CHAT_INTER_SHOW_BARRAGE'] &&
              that.events['CHAT_INTER_SHOW_BARRAGE'](msg);
          });
        }
        //喇叭消息
        else if (custom.action == '8-1') {
          that.events['TRUMPET_DATA_CHANGE'] &&
            that.events['TRUMPET_DATA_CHANGE'](msg);
          //世界喇叭，需要展示对应的DOM
          that.events['CHAT_WORLD_TRUMPET_CHANGE'] &&
            that.events['CHAT_WORLD_TRUMPET_CHANGE'](msg);
        }
        //更新神豪位
        else if (custom.action == '11-1') {
          addDefaultMsg({ type: 'custom', custom: custom });
          that.events['CHANGE_LIVE_CONFIG'] &&
            that.events['CHANGE_LIVE_CONFIG'](custom);
        }
        //中奖高级特效
        else if (custom.action == '50-50') {
          // todo 互动游戏模板且在游戏中不展示礼物特效，横幅
          const isInteractGame =
            that?.roomInfo?.custom?.rmode === 4 &&
            that.gameInteractData?.pkStatus === 1;
          if (!isInteractGame) {
            that.events['START_GIFT_USPER_MOVE'] &&
              that.events['START_GIFT_USPER_MOVE']({
                gift_url: custom.winningPc,
                app_voice: custom.winningSound,
                gift_price: 3000,
                gift_num: 1,
              });
          }
        }
        //跨房PK挑战发起
        else if (custom.action == '60-1') {
          that.events['ROOM_PK_START'] && that.events['ROOM_PK_START'](custom);
        }
        //跨房PK挑战开始
        else if (custom.action == '60-2') {
          that.events['ROOM_PK_DOING'] && that.events['ROOM_PK_DOING'](custom);
        }
        //跨房PK挑战结束
        else if (custom.action == '60-3') {
          that.events['ROOM_PK_END'] && that.events['ROOM_PK_END'](custom);
        }
        //跨房PK挑战结束
        else if (custom.action == '60-6') {
          that.events['ROOM_PK_READY'] && that.events['ROOM_PK_READY'](custom);
        }
        //房内PK挑战开始
        else if (custom.action == '70-0') {
          that.events['TEAM_PK_START'] && that.events['TEAM_PK_START'](custom);
        }
        //房内PK挑战结束
        else if (custom.action == '70-1') {
          that.events['TEAM_PK_END'] && that.events['TEAM_PK_END'](custom);
        }
        //房内PK异常结束
        else if (custom.action == '70-2') {
          that.events['TEAM_PK_ERROR'] && that.events['TEAM_PK_ERROR'](custom);
        }
        //红包结束
        else if (custom.action == '12-1') {
          that.events['RED_PACKET_END'] &&
            that.events['RED_PACKET_END'](custom);
        }
        //领取红包
        else if (custom.action == '12-6') {
          that.events['ROB_RED_PACKET'] &&
            that.events['ROB_RED_PACKET'](custom);
        }
        // 新礼物升级通知
        else if (custom.action == 'USER_GIFT_LEVEL_UP') {
          if (custom.userId == that.uid) {
            that.events['USER_GIFT_LEVEL_UP'] &&
              that.events['USER_GIFT_LEVEL_UP'](custom);
          }
        }
        // 活动模板节目单变化
        else if (custom.action == 'ROOM_STAR_PROGRAM_SING_NOTIFY') {
          that.events['ROOM_STAR_PROGRAM_SING_NOTIFY'] &&
            that.events['ROOM_STAR_PROGRAM_SING_NOTIFY'](custom);
        }
        //清屏
        else if (custom.action == '12-5') {
          //消息清空
          that.events['CLEAR_ROOM_MESSAGE'] &&
            that.events['CLEAR_ROOM_MESSAGE']();
          //高级礼物动画
          that.events['START_GIFT_USPER_MOVE_DESTROY'] &&
            that.events['START_GIFT_USPER_MOVE_DESTROY']();
          //普通礼物动画
          that.events['START_GIFT_MOVE_DESTROY'] &&
            that.events['START_GIFT_MOVE_DESTROY']();
          //用户入场动画
          that.events['VIP_MEMBER_ENTER_DESTROY'] &&
            that.events['VIP_MEMBER_ENTER_DESTROY']();
          //喇叭动画
          that.events['TRUMPET_DATA_CHANGE_DESTROY'] &&
            that.events['TRUMPET_DATA_CHANGE_DESTROY']();
          //弹幕动画
          that.events['HIDE_BARRAGE'] && that.events['HIDE_BARRAGE']();
        }
        //点唱下单成功
        else if (custom.action == '80-50') {
          that
            .getMemberInfo(
              Util.$analyToAccount(custom.fromExt.uid),
              false,
              '点唱'
            )
            .then((user) => {
              msg.user = { ...user };
              addDefaultMsg(msg);
            });
        }
        //派单厅 65-1: 直接下单成功 65-3 要上麦点单
        else if (custom.action == '65-1' || custom.action == '65-3') {
          that
            .getMemberInfo(Util.$analyToAccount(custom.uid), false, '派单厅')
            .then((user) => {
              msg.user = { ...user };
              addDefaultMsg(msg);
            });
        }
        //通用消息
        else if (custom.action == 'ROOM_MSG_NICKNAME_TEXT') {
          addDefaultMsg(msg);
        }
        //新增自定义表情 todo 2.9.4
        else if (custom.action == 'ROOM_MSG_STICKER') {
          that.getMemberInfo(msg.from, false, '自定义表情').then((user) => {
            msg.user = { ...user };
            addDefaultMsg(msg);
          });
        }
        // 即构版权音乐下载完成回调主持人监听
        else if (custom.action == '103-1') {
          if (that.isMaster()) {
            that.events['COPYRIGHT_DOWNLOAD_FINISH'] &&
              that.events['COPYRIGHT_DOWNLOAD_FINISH'](custom);
          }
        }
        // 互动游戏加入阵营
        else if (custom.action === 'INTERACTIVE_GAME_JOIN_TEAM') {
          const account = Util.$analyToAccount(custom.uid);
          setGameInteractCamp(
            custom.uid,
            custom.campid,
            that.me.account === account
          );
          if (custom?.campid && that.me.account === account) {
            if (custom.joinType === 1) {
              const campText = CAMP_ENUM?.[custom.campid] || null;
              let content = `您本局游戏首次送礼给了${campText}大神，已默认为您加入${campText}阵营，接下来给${campText}大神送礼才有游戏效果哦~`;
              if (campText) {
                Modal.info({
                  title: '提示',
                  icon: null,
                  closable: true,
                  centered: true,
                  className: 'daidai-confirm-style font-size-16',
                  content,
                  okText: '我知道了',
                });
              }
            }
          }
          that
            .getMemberInfo(account, false, '互动游戏加入阵营')
            .then((user) => {
              addDefaultMsg({ ...msg, user: { ...user } });
            });
        }
        // 互动游戏公屏消息
        else if (custom.action == 'INTERACTIVE_GAME_ASSIST_TEAM') {
          that
            .getMemberInfo(
              Util.$analyToAccount(custom.uid),
              false,
              '互动游戏公屏消息'
            )
            .then((user) => {
              addDefaultMsg({ ...msg, user: { ...user } });
            });
        }
        // 魔盒公屏消息
        else if (custom.action == 'INTERACTIVE_GAME_ROOM_SCREEN') {
          that
            .getMemberInfo(
              Util.$analyToAccount(custom.uid),
              false,
              '魔盒公屏消息'
            )
            .then((user) => {
              addDefaultMsg({ ...msg, user: { ...user } });
            });
        }
        // 小游戏结算弹窗
        else if (custom.action == '704-3') {
          that.events['ROOM_MINI_GAME_RESULT'] &&
            that.events['ROOM_MINI_GAME_RESULT'](custom);
        }
        // 巅峰赛对决即将开始弹窗提醒
        else if (custom.action === 'ROOM_PEAK_PK_REMIND_NEW') {
          that.events['ROOM_PEAK_PK_REMIND_NEW'] &&
            that.events['ROOM_PEAK_PK_REMIND_NEW'](custom);
        }
        // 魔盒公屏消息
        else if (custom.action === '104-1') {
          addDefaultMsg(msg);
        }
        // 互动游戏跨房PK邀请通知 todo 2.40.0 版本调整，老版本保留，后期可以删除
        else if (custom.action === 'INTERACTIVE_GAME_CROSS_ROOM_PK_REQUEST') {
          if (that.isMaster()) {
            that.events['INTERACTIVE_GAME_CROSS_ROOM_PK_REQUEST'] &&
              that.events['INTERACTIVE_GAME_CROSS_ROOM_PK_REQUEST'](custom);
          }
        }
        // 互动游戏跨房PK拒绝邀请
        else if (custom.action === 'INTERACTIVE_GAME_CROSS_ROOM_PK_REJECT') {
          if (that.isMaster()) {
            that.events['INTERACTIVE_GAME_CROSS_ROOM_PK_REJECT'] &&
              that.events['INTERACTIVE_GAME_CROSS_ROOM_PK_REJECT'](custom);
          }
        }
        // 互动游戏跨房PK房间启动异常 红方提示语
        else if (custom.action === 'INTERACTIVE_GAME_CROSS_ROOM_PK_START_EX') {
          if (that.isMaster()) {
            that.events['INTERACTIVE_GAME_CROSS_ROOM_PK_START_EX'] &&
              that.events['INTERACTIVE_GAME_CROSS_ROOM_PK_START_EX'](custom);
          }
        }
        // 互动游戏跨房PK提醒主控开始消息
        else if (
          custom.action === 'INTERACTIVE_GAME_CROSS_ROOM_PK_NOTICE_START'
        ) {
          if (that.isMaster()) {
            message.info(custom?.viewContent || `提醒开始游戏`);
          }
        }
        // 互动游戏跨房PK邀请消息
        else if (
          custom.action === 'INTERACTIVE_GAME_CROSS_ROOM_PK_REQUEST_V2'
        ) {
          if (that.isMaster()) {
            that.events['INTERACTIVE_GAME_CROSS_ROOM_PK_REQUEST_V2'] &&
              that.events['INTERACTIVE_GAME_CROSS_ROOM_PK_REQUEST_V2'](custom);
          }
        }
        // 互动游戏跨房PK游戏大厅列表变更通知
        else if (
          custom.action === 'INTERACTIVE_GAME_CROSS_ROOM_PK_HALL_LIST_CHANGE'
        ) {
          that.events['INTERACTIVE_GAME_CROSS_ROOM_PK_HALL_LIST_CHANGE'] &&
            that.events['INTERACTIVE_GAME_CROSS_ROOM_PK_HALL_LIST_CHANGE'](
              custom
            );
        }
        // 互动游戏跨房PK游戏大厅列表变更通知
        else if (custom.action === 'INTERACTIVE_GAME_CROSS_ROOM_PK_KICK_OUT') {
          custom.msg && message.warning(custom.msg);
        }
        // 亲密关系上麦动效
        else if (custom.action === 'INTIMATE_UP_MICROPHONE_SPECIAL_EFFECTS') {
          const account = Util.$analyToAccount(custom.uid);
          const eventKey = `MIC_GIFT_EFFECT_${account}`;
          // 我自己亲密关系的麦位动效
          custom?.micAnimationIcon &&
            that.events[eventKey] &&
            that.events[eventKey]({
              account,
              mic_gif: custom.micAnimationIcon,
              name: custom.uid,
              delay: custom.micAnimationTime * 1000,
              origin: 'intimate',
            });
          // 亲密关系上麦动效
          if (custom?.items?.length) {
            custom.items.forEach((item) => {
              const account = Util.$analyToAccount(item.uid);
              const eventKey = `MIC_GIFT_EFFECT_${account}`;
              item?.micAnimationIcon &&
                that.events[eventKey] &&
                that.events[eventKey]({
                  account,
                  mic_gif: item.micAnimationIcon,
                  name: item.uid,
                  delay: item.micAnimationTime * 1000,
                  origin: 'intimate',
                });
            });
          }
        }
        //用户在某个福袋参与资格状态消息通知 (房间消息)
        else if (custom.action === 'LUCKY_BAG_PART_USER_NOTIFY') {
          that.events['CHANGE_ROOM_LUCKY_BAG_STATUS'] && that.events['CHANGE_ROOM_LUCKY_BAG_STATUS'](custom);
        }
        //房间福袋开奖结果通知消息: (房间消息)
        else if (custom.action === 'LUCKY_BAG_REWARD_RESULT_NOTIFY') {
          that.events['CHANGE_ROOM_LUCKY_BAG_END'] && that.events['CHANGE_ROOM_LUCKY_BAG_END'](custom);
        }
      }
    } catch (error) {
      console.error('room-msg-error:', error);
      console.log(msg);
      _anly_seng_custom(1702, { params: msg, data: error.message });
    }
  }
  //禁音处理
  function changeMeMicState({
    disAudio, // true 禁言， false 取消禁言
    isChangeIndex = false, // 是否切换麦位
    isSync = false, // 是否同步云信
    isGameOperate = false, // 是否为小游戏控制中
    isMasterDisAudio, // 是否是主播禁音
  }) {
    let queue_me = cloneDeep(that.queueObject[that.me.account]);
    if (queue_me) {
      queue_me.disAudio = disAudio; // disAudio true 禁言， false 取消禁言
      //互动者
      if (disAudio) {
        const { isAgoraRTC } = that.getBase();
        if (isAgoraRTC) {
          that.showSpeakUsers([{ uid: that.uid, roomid: that.roomid, isSpeak: false }]);
        } else {
          that.showSpeakUsersZEGO(that.uid, that.roomid, false);
        }
      }
      if (that.webrtc && !isGameOperate) {
        that.webrtc.changeMicState({
          open: !disAudio,
          callback: () => {
            // 切换麦位，且非主持人禁言的情况下，闭麦的情况下提醒用户
            if (!isMasterDisAudio && isChangeIndex && !!disAudio) {
              message.info('您当前麦克风为关闭状态，请打开麦克风交流');
            }
          },
        });
      }
      // 非服务端上麦，和切换麦位的情况下同步麦位队列信息
      // (isSync || isChangeIndex) && isDiff && that.queueOffer(that.me.account, queue_me);
      isSync && that.queueOffer(that.me.account, queue_me);
    }
  }
  //魔法表情绑定
  function bindGiftEmoji(dom, gif, num) {
    //删除原有的
    let old = dom.querySelector('.gift-emoji');
    if (old) {
      old.style.display = 'none';
    }
    if (gif.id == 'shouzhang') {
      let emoji = document.createElement('span');
      emoji.className = 'gift-emoji shouzhang-1';
      dom.appendChild(emoji);
      shouzhang(dom, emoji, 12, num);
    } else if (gif.id == 'gold') {
      let emoji = document.createElement('span');
      emoji.className = 'gift-emoji gold-1';
      dom.appendChild(emoji);
      gold(dom, emoji, 24, num);
    } else {
      let emoji = document.createElement('span');
      emoji.className = 'gift-emoji fadeIn animated faster';
      emoji.innerHTML = `<img src="${Util.transImgUrl(gif.pic)}"/>`;
      dom.appendChild(emoji);
      setTimeout(() => {
        dom?.removeChild && dom.removeChild(emoji);
      }, 4000);
    }
  }
  //随机魔法
  function shouzhang(dom, emoji, n, num) {
    if (n > 0) {
      emoji.className = `gift-emoji shouzhang-${(n % 3) + 1}`;
      setTimeout(function () {
        shouzhang(dom, emoji, --n, num);
      }, 200);
    } else {
      emoji.className = `gift-emoji shouzhang-${num}`;
      setTimeout(function () {
        dom?.removeChild && dom.removeChild(emoji);
      }, 4000);
    }
  }
  //随机魔法
  function gold(dom, emoji, n, num) {
    if (n > 0) {
      emoji.className = `gift-emoji gold-move-${(n % 8) + 1}`;
      setTimeout(function () {
        gold(dom, emoji, --n, num);
      }, 200);
    } else {
      emoji.className = `gift-emoji gold-${num}`;
      setTimeout(function () {
        dom?.removeChild && dom.removeChild(emoji);
      }, 4000);
    }
  }
  //用户资料整合
  function convertUserInfo(msg, isSetMe = false) {
    const account = msg?.account || msg?.attach?.to?.[0] || msg?.from || null;
    let member = null;
    if (!account) return null;

    if (!msg?.idClient) {
      member = msg;
      member.custom = (msg?.custom && Util.isJSONStr(msg.custom)) ? JSON.parse(msg.custom) : {};
    } else {
      member = that.members[account];
      const nick = msg?.attach?.fromNick || msg?.fromNick || msg?.nick || "";
      const avatar = msg?.avatar || msg?.fromAvatar || "";

      if (!member) {
        const custom = msg.fromCustom && Util.isJSONStr(msg.fromCustom) ? JSON.parse(msg.fromCustom) : {};
        member = {
          account,
          nick,
          avatar,
          custom,
          gaged: msg?.attach?.gaged || null,
          tempMuteDuration: msg?.attach?.tempMuteDuration || 0,
          tempMuted: msg?.attach?.tempMuted || null,
          enterTime: msg.time,
          updateTime: Date.now(),
          online: true,
          blacked: false,
          type: 'guest',
        };
      } else if (msg?.fromCustom) {
        member.custom = (msg?.fromCustom && Util.isJSONStr(msg.fromCustom)) ? JSON.parse(msg.fromCustom) : {};
      }
      if (!member.custom) {
        const { rootConfig, channelId, clientInfo, client } = that.getBase();
        member.custom = {
          sign: '这个人很懒,  还没有设置签名', //签名
          sex: 0, //性别
          ifGod: 0, //是否是大神
          wealthAmount: 0, //财富值
          wealthLevel: '0_0', //财富等级
          glamourAmount: 0, //魅力值
          glamourLevel: '0_0', //魅力等级
          vipId: 0, //房间会员
          channelId: channelId,
          client: client,
          web_version: rootConfig.version, //网页独有版本参数
          pc_version: clientInfo.version, //pc独有版本参数
          is_default_custom: true, // 用于标识，云信消息中未获取到拓展信息，使用的是默认的
        };
      }
    }
    // todo 由于移动端重连可能不触发 memberenter 消息，所以当触发 updateMemberInfo 消息时，强行将 online 设置为 true
    if (msg?.attach?.type === "updateMemberInfo") {
      member.online = true;
    }
    // 进入房间使出化数据使用云信回调数据，确保数据正确
    if (member?.custom?.avator) {
      member.avatar = member.custom.avator;
    }
    if (member?.custom?.nick) {
      member.nick = member.custom.nick;
    }
    that.members[account] = { ...member };

    // 如果是我自己则通知更新
    if (that.account === account) {
      that.me = member;
      if (!isSetMe) {
        that.events['CHANGE_ME'] && that.events['CHANGE_ME'](that.me);
        that.events['CHANGE_ROOM_ME'] && that.events['CHANGE_ROOM_ME'](that.me);
      }
    }

    return member;
  }
  //添加公屏消息
  function addDefaultMsg(msg) {
    that.events['CHANGE_ROOM_MESSAGE'] &&
      that.events['CHANGE_ROOM_MESSAGE'](msg);
  }
  //批量获取在线成员列表
  function getOnlineMembers(callback) {
    if (!that.conn) return;
    that.room.getChatroomMembers({
      guest: false,
      onlyOnline: true,
      limit: 50,
      done: (error, obj) => {
        const curOnlineMembers = {};
        if (obj && obj.members) {
          obj.members.forEach((member) => {
            member.online = true;
            convertUserInfo(member);
            member?.account &&
              (curOnlineMembers[member.account] = member.account); // 更新在线成员列表
          });
        }
        that.room.getChatroomMembers({
          guest: true,
          onlyOnline: true,
          limit: 50,
          done: (error1, obj1) => {
            if (obj1 && obj1.members) {
              obj1.members.forEach((member) => {
                member.online = true;
                convertUserInfo(member);
                member?.account &&
                  (curOnlineMembers[member.account] = member.account); // 更新在线成员列表
              });
            }
            that.onlineMembers = curOnlineMembers;

            const showCount = Object.keys(that.onlineMembers).length;
            that.events['CHANGE_ONLINE_MEMBER'] && that.events['CHANGE_ONLINE_MEMBER'](that.onlineMembers, showCount);

            callback && callback(obj.members.concat(obj1.members));
          },
        });
      },
    });
  }
  //进入上报
  function roomEnter() {
    //上报
    HTTP._room_enter({ uid: that.uid, roomid: that.roomid });
    //上报
    _dssp_send_click(30, {
      uid: that.uid,
      room_id: that.roomid,
      event_timestamp: Date.now(),
    });
    //自定义 socket.io 房间状态上报
    window.wio &&
      window.wio.emit(
        'chatStatus',
        JSON.stringify({
          status: 1,
          uid: that.uid,
          roomid: that.roomid,
          timestamp: Date.now(),
        })
      );
  }
  //用户资料变更
  async function updateMemberMsg(msg) {
    const {baseConstants} = that.getBase();
    let {custom, to} = msg.attach;
    let user = convertUserInfo(msg); // todo 2025.07.18 优先获取IM消息中的用户信息
    // todo 异常场景，移动端在房间内断线，然后重连会触发 memberConfigChange 手动更新在线列表
    if (custom.indexOf('memberConfigChange') !== -1 && !that.onlineMembers[to[0]]) {
      if (user.custom?.is_default_custom) { // 云信消息中未获取到拓展信息,则从云信云端获取
        user = await that.getMemberInfo(to[0], true, "memberConfigChange");
      }
      that.joinOnlineMember(to[0], user, null, "updateMemberMsg");
    }
    if (custom.indexOf('memberEnter') !== -1) {
      user.online = true; // 用户进入房间强制将其设置为在线状态
      that.joinOnlineMember(to[0], user, null, 'memberEnter2');
      // 特权隐藏动画
      if (user.custom.enterRoomHide == 1) return;
      // 帝皇财富特权，隐藏进场
      addDefaultMsg({...msg, user: {...user}});
      // todo 互动游戏模板且在游戏中不展示礼物特效，横幅
      const isInteractGame =
        that?.roomInfo?.custom?.rmode === 4 &&
        that?.gameInteractData?.pkStatus === 1;
      // 屏蔽动画
      if (that.shieldMove.DisRoomEnter || isInteractGame) return;
      const enterEffectInfo = {nick: user.nick};
      // 进场秀
      if (user?.custom?.effectShowV2?.showPic) {
        enterEffectInfo.origin = 'effect';
        enterEffectInfo.showPic = user.custom.effectShowV2.showPic;
      } else if (user?.custom?.car?.showPic) {
        const sessionKey = `dd_car_show_${user.account}`;
        const userCacheShow = Util.readSession(sessionKey);
        const limit = baseConstants?.length
          ? baseConstants.find((n) => n.code === 'carEffectShowFrequency')
          : null;
        const count = Number(userCacheShow?.value || 0);
        const limitCount = Number(limit?.message || 0);
        if (limitCount) {
          // 如果限制，并且不是自己
          if (!count || count < limitCount) {
            Util.setSession(
              sessionKey,
              count + 1,
              1 / 24 / 60,
              userCacheShow?.expires || null
            );
            // 座驾
            enterEffectInfo.origin = 'car';
            enterEffectInfo.showPic = user.custom.car.showPic;
          }
        } else {
          // 如果没有限制则播放
          enterEffectInfo.origin = 'car';
          enterEffectInfo.showPic = user.custom.car.showPic;
        }
      }
      if (enterEffectInfo?.showPic) {
        that.events['VIP_MEMBER_ENTER'] &&
        that.events['VIP_MEMBER_ENTER'](enterEffectInfo);
      }
    } else if (custom.indexOf('memberSKCard') != -1) {
      if (that.hasQueume(user.account) && that.events['CHANGE_LIVE_CONFIG']) {
        that.events['CHANGE_LIVE_CONFIG']({
          action: 'memberSKCard',
          account: user.account,
        });
      }
    } else if (custom === 'memberInfoChange') {
      // 用户被处罚，需要更新用户数据
      if (user.custom?.is_default_custom) { // 云信消息中未获取到拓展信息,则从云信云端获取
        that.getMemberInfo(user.account, true, "memberInfoChange").then(info => {
          if (that.members[user.account]) {
            /// 触发更新
            // 在线列表
            changeOnlineMemberCount(0, false, "memberInfoChange");
            // 麦位
            that.events['CHANGE_ONE_USER_INFO'] && that.events['CHANGE_ONE_USER_INFO'](info);
          }
        });
      } else {
        if (that.members[user.account]) {
          /// 触发更新
          // 在线列表
          changeOnlineMemberCount(0, false, 'memberInfoChange');
          // 麦位
          that.events['CHANGE_ONE_USER_INFO'] && that.events['CHANGE_ONE_USER_INFO'](user);
        }
      }
    }
  }
  //更新在线成员数量
  const getChatRoomOnlineNum = throttle(() => {
    getChatRoomInfo(() => {
      // 获取在线成员列表
      getOnlineMembers();
    });
  }, 20 * 1000)
  //获取直播间信息
  function getChatRoomInfo(callback) {
    if (!that.conn) return;
    that.queryOnlineCountTimer = Date.now(); // 用于标记获取房间在线人数的时间戳
    that.room.getChatroom({
      done: (error, obj) => {
        if (!error) {
          saveChatRoomInfo(obj.chatroom);
          callback && callback();
        } else {
          console.error('getChatroom err', error);
        }
      },
    });
  }
  //存储直播间信息
  function saveChatRoomInfo(chatroom, callback) {
    if (!chatroom) return;
    _set_store_roomid(chatroom.id);
    let custom = JSON.parse(chatroom.custom);
    if (custom.data && custom.data != '') {
      custom.data = JSON.parse(custom.data);
    }
    chatroom.custom = custom;
    chatroom.roomNo = custom && custom.roomNo ? custom.roomNo : null;
    that.roomInfo = chatroom;
    that.events['CHANGE_ROOM'] && that.events['CHANGE_ROOM'](that.roomInfo);
    that.events['CHANGE_ROOM_INFO'] &&
      that.events['CHANGE_ROOM_INFO'](that.roomInfo);
    //派单数量变更
    if (that.roomInfo.custom && that.roomInfo.custom.rmode == 6) {
      that.events['CHANGE_ORDER_COUNT'] &&
        that.events['CHANGE_ORDER_COUNT'](that.roomInfo);
    }
    //在线人数更新
    changeOnlineMemberCount(chatroom.onlineMemberNum, true, 'saveChatRoomInfo');
    callback && callback();
  }
  //获取队列所有元素
  function getQueueList(key, callback) {
    if (that.queChangeTime && Date.now() - that.queChangeTime < 3000) {
      that.queueBlockNum += 1;
      return;
    }
    that.queueBlockNum = 0; //高频阻断
    that.queueChangeCount = 0; //自解析叠加
    that.room.queueList({
      done: (err, obj, content) => {
        //更新限制时间节点
        that.queChangeTime = Date.now();
        let queueList = []; //互动成员列表
        let queueObject = {}; //队列元素列表
        let queueLine = []; //申请排麦列表
        let userAccounts = [];
        that.positionTime = [];
        that.godHowe = null;
        that.roomPK = null;
        that.teamPK = null;
        that.gameInteractData = null; // 互动游戏队列信息
        if (content && content.queueList) {
          content.queueList.forEach((item) => {
            for (let key in item) {
              //麦位
              if (key.indexOf('wp_') != -1) {
                let qValue = JSON.parse(item[key]);
                queueObject[key] = { ...qValue };
                queueList.push({ ...qValue });
                if (!that.members[qValue.account]) {
                  userAccounts.push(qValue.account);
                }
              }
              //排麦
              else if (key.indexOf('queue_') != -1) {
                let qValue = JSON.parse(item[key]);
                queueObject[key] = { ...qValue };
                queueLine.push({ ...qValue });
                if (!that.members[qValue.account]) {
                  userAccounts.push(qValue.account);
                }
              }
              //直播配置
              else if (key == 'MIC_CONFIG_DATA') {
                let qValue = JSON.parse(item[key]);
                queueObject[key] = { ...qValue };
                that.liveConfig = qValue;
              }
              //相亲数据
              else if (key == 'DATING_DATA') {
                let qValue = JSON.parse(item[key]);
                queueObject[key] = { ...qValue };
                that.datingData = qValue;
              }
              //心动池数据
              else if (key == 'HEARTBEAT_DATA') {
                let qValue = JSON.parse(item[key]);
                queueObject[key] = { ...qValue };
                that.heartbeatData = qValue;
              }
              //麦位倒计时
              else if (key == 'POSITION_TIMER') {
                let qValue = JSON.parse(item[key]);
                queueObject[key] = { ...qValue };
                that.positionTime = qValue.sdata || [];
              }
              //神豪位
              else if (key == 'GAD_HOWE') {
                let qValue = JSON.parse(item[key]);
                queueObject[key] = { ...qValue };
                that.godHowe = qValue.sdata || null;
              }
              //跨房PK
              else if (key == 'ROOMPK_DATA') {
                let qValue = JSON.parse(item[key]);
                queueObject[key] = { ...qValue };
                that.roomPK = qValue;
              }
              //房内PK
              else if (key == 'TEAM_PK_DATA') {
                let qValue = JSON.parse(item[key]);
                queueObject[key] = { ...qValue };
                that.teamPK = qValue;
              }
              //派单信息
              else if (key == 'ROOM_DISPATCH_ORDER_ACTION') {
                let qValue = JSON.parse(item[key]);
                queueObject[key] = { ...qValue };
                that.sendOrders = qValue;
              }
              // 互动游戏信息
              else if (key == 'INTERACTIVE_GAME_DATA') {
                let qValue = JSON.parse(item[key]);
                queueObject[key] = { ...qValue };
                that.gameInteractData = qValue;
              }
              // 第三方游戏数据变更
              else if (key == 'MINE_GAME_KEY_7eb32fc5be54') {
                let qValue = JSON.parse(item[key]);
                queueObject[key] = { ...qValue };
                that.gameOtherMicData = qValue;
              } else if (key == 'GIFT_MICROPHONE_SLOT_EFFECTS') {
                let qValue = JSON.parse(item[key]);
                queueObject[key] = { ...qValue };
                that.micLongEffectData = qValue?.items || [];
              }
              //非常规队列
              else {
                let qValue = JSON.parse(item[key]);
                queueObject[key] = qValue;
              }
            }
          });
        }
        //互动成员列表
        that.queueList = [...queueList];
        //互动成员数据集合
        that.queueObject = { ...queueObject };
        //麦序成员列表
        that.queueLine = [...queueLine];
        //变更 执行对应事件
        if (userAccounts.length > 0) {
          that.getMembersInfo(userAccounts, () => {
            queueEventChange(key, callback);
          });
        } else {
          queueEventChange(key, callback);
        }
        //阻塞 补充更新
        setTimeout(() => {
          that.queueBlockNum && getQueueList();
        }, 3100);
      },
    });
  }
  //队列事件变更
  function queueEventChange(key, callback) {
    //直播配置
    if (key == 'MIC_CONFIG_DATA') {
      //直播数据变更
      that.events['CHANGE_LIVE_CONFIG'] && that.events['CHANGE_LIVE_CONFIG']();
      //相亲数据变更
      that.events['CHANGE_LIVE_DATING'] && that.events['CHANGE_LIVE_DATING']();
    }
    //心动值数据
    else if (key == 'HEARTBEAT_DATA') {
      that.events['CHANGE_LIVE_CONFIG'] && that.events['CHANGE_LIVE_CONFIG']();
    }
    //麦位倒计时
    else if (key == 'POSITION_TIMER') {
      that.events['CHANGE_LIVE_CONFIG'] && that.events['CHANGE_LIVE_CONFIG']();
    }
    //神豪位
    else if (key == 'GAD_HOWE') {
      that.events['CHANGE_LIVE_CONFIG'] && that.events['CHANGE_LIVE_CONFIG']();
    }
    //跨房PK
    else if (key == 'ROOMPK_DATA') {
      that.events['ROOM_PK_CHANGE'] &&
        that.events['ROOM_PK_CHANGE'](that.queueObject.ROOMPK_DATA);
      that.events['CHANGE_LIVE_CONFIG'] && that.events['CHANGE_LIVE_CONFIG']();
    }
    //房内PK
    else if (key == 'TEAM_PK_DATA') {
      that.events['TEAM_PK_CHANGE'] &&
        that.events['TEAM_PK_CHANGE'](that.queueObject.TEAM_PK_DATA);
      that.events['CHANGE_LIVE_CONFIG'] && that.events['CHANGE_LIVE_CONFIG']();
    }
    //相亲数据变更
    else if (key == 'DATING_DATA') {
      that.events['CHANGE_LIVE_DATING'] && that.events['CHANGE_LIVE_DATING']();
    }
    //派单信息变更
    else if (key == 'ROOM_DISPATCH_ORDER_ACTION') {
      that.events['ROOM_DISPATCH_ORDER_ACTION_BOOS'] &&
        that.events['ROOM_DISPATCH_ORDER_ACTION_BOOS']();
      that.events['ROOM_DISPATCH_ORDER_ACTION_MASTER'] &&
        that.events['ROOM_DISPATCH_ORDER_ACTION_MASTER']();
    }
    //福袋
    else if (key == 'LUCKY_BAG') {
      that.events['CHANGE_ROOM_LUCKY_BAG'] && that.events['CHANGE_ROOM_LUCKY_BAG']();
    }
    //2025年度活动助力熊
    else if (key == 'NDSD_ROOM_ZLX_2025') {
      that.events['CHANGE_YEAR_ROOM_TASK'] && that.events['CHANGE_YEAR_ROOM_TASK']();
    }
    //2025年度活动红包雨
    else if (key == 'NDSD_ROOM_LUCKY_BAG_2025') {
      that.events['CHANGE_YEAR_ROOM_BAG'] && that.events['CHANGE_YEAR_ROOM_BAG']();
    }
    //2025年度活动带带熊
    else if (key == 'NDSD_ROOM_DDX_2025') {
      that.events['CHANGE_YEAR_ROOM_BOX'] && that.events['CHANGE_YEAR_ROOM_BOX'](true);
    }
    //其他
    else {
      //队列成员更新
      that.events['CHANGE_QUEUE_DATA'] && that.events['CHANGE_QUEUE_DATA']();
      //直播配置
      that.events['CHANGE_LIVE_CONFIG'] && that.events['CHANGE_LIVE_CONFIG']();
      //相亲数据变更
      that.events['CHANGE_LIVE_DATING'] && that.events['CHANGE_LIVE_DATING']();
      //排麦列表变更
      that.events['CHENG_ROOM_QUEUES'] && that.events['CHENG_ROOM_QUEUES']();
      //计算个人排麦状态
      that.events['CHENG_ROOM_QUEUE_ACTION'] && that.events['CHENG_ROOM_QUEUE_ACTION']();
      //排麦列表变更
      that.events['QUEUE_LIST_CHANGW'] && that.events['QUEUE_LIST_CHANGW']();
      //清屏权限
      that.events['ROOM_MIC_CONFIG_TOP'] && that.events['ROOM_MIC_CONFIG_TOP']();
      //跨房PK
      that.events['ROOM_PK_CHANGE'] && that.events['ROOM_PK_CHANGE'](that.queueObject.ROOMPK_DATA);
      //房内PK
      that.events['TEAM_PK_CHANGE'] && that.events['TEAM_PK_CHANGE'](that.queueObject.TEAM_PK_DATA);
      //派单信息
      that.events['ROOM_DISPATCH_ORDER_ACTION_BOOS'] && that.events['ROOM_DISPATCH_ORDER_ACTION_BOOS']();
      that.events['ROOM_DISPATCH_ORDER_ACTION_MASTER'] && that.events['ROOM_DISPATCH_ORDER_ACTION_MASTER']();
      // 当前正在演唱的歌曲信息
      that.events['CLICK_MUSIC_CHANGE_ING'] && that.events['CLICK_MUSIC_CHANGE_ING']();
      that.events['CLICK_MUSIC_CHANGE_LIST'] && that.events['CLICK_MUSIC_CHANGE_LIST']();
      if (that?.roomInfo?.custom?.rmode === 36) {
        // 初始化更新歌单
        that.events['CLICK_MUSIC_LIST_UPDATE'] && that.events['CLICK_MUSIC_LIST_UPDATE']();
      }
      if (that?.roomInfo?.custom?.rmode === 37) {
        // 初始化更新歌单
        that.events['ROOM_STAR_PROGRAM_SING_NOTIFY'] && that.events['ROOM_STAR_PROGRAM_SING_NOTIFY']();
      }

      if (window.tempRoomId == null) {
        window.tempRoomId = 1;
        //红包雨
        that.events['CHANGE_YEAR_ROOM_BAG'] && that.events['CHANGE_YEAR_ROOM_BAG']();
        //带带熊
        that.events['CHANGE_YEAR_ROOM_BOX'] && that.events['CHANGE_YEAR_ROOM_BOX'](true);
        //助力熊
        that.events['CHANGE_YEAR_ROOM_TASK'] && that.events['CHANGE_YEAR_ROOM_TASK']();
        //福袋
        that.events['CHANGE_ROOM_LUCKY_BAG'] && that.events['CHANGE_ROOM_LUCKY_BAG']();
      }
    }
    callback && callback();
    //如果我不在队列直播中， 当时当前本地设备还开启
    if (that.roomInfo && that.roomInfo.custom) {
      let meque = that.hasQueume();
      //先队列,后直播
      if (meque) {
        that.webrtc && that.webrtc.publishLocalStream(meque);
      }
      //多频次 执行声网下麦
      else {
        that.webrtc && that.webrtc.delToMic(1);
      }
    }
  }

  //初始化直播数据
  function initLiveConfig() {
    let liveConfig = {
      config: [],
    };
    for (let i = 0; i < 9; i++) {
      liveConfig.config.push({
        disAudio: false,
        enabled: i == 0 ? true : false,
        index: i,
        microphone: true,
        type: i == 0 ? 0 : 1,
      });
    }
    that.liveConfig = liveConfig;
  }
  //在线成员人数变更
  function changeOnlineMemberCount(n, reset, origin) {
    if (reset) that.onlineMemberCount = n;
    else that.onlineMemberCount += n;
    let count = 0;
    for (let i in that.onlineMembers) {
      if (that.onlineMembers[i]) count += 1;
    }
    let showCount = that.onlineMemberCount;
    if (showCount < count) showCount = count;
    //如果 数据出现差异
    if (that.onlineMemberCount !== count && count < 50) {
      getChatRoomOnlineNum();
    }
    that.events['CHANGE_ONLINE_MEMBER'] && that.events['CHANGE_ONLINE_MEMBER'](that.onlineMembers, showCount);

    // 由用户进出时，同步在线人数，避免误差较大
    // 初始化时不获取在线人数
    // 与上一次获取在线人数间隔每30分钟同步一次
    const now = Date.now();
    if (
      now - that.createTime > 20 * 1000 &&
      now > (that?.queryOnlineCountTimer || 0) + 30 * 60 * 1000
    ) {
      console.log(
        'sync online member',
        now,
        that.queryOnlineCountTimer,
        that.onlineMemberCount
      );
      getChatRoomOnlineNum();
    }
  }
  //显示说话成员
  that.showSpeakUsers = (members) => {
    const users = [];
    // 麦位的用户
    that.queueList.forEach(item => (item.account && users.push({
      uid: Util.$analyToUid(item.account),
      roomid: that.roomid,
    })));

    // 麦位投屏的用户
    const data = that.queueObject?.["SUB_ROOM_MIC_IMAGE"] || null;
    if (data?.micUsers?.length) {
      const micUsers = data.micUsers || [];
      const roomid = data.mainRoomId || true;
      const enableMic = data?.muteEnable || false;
      micUsers.forEach(item => users.push({
        uid: item.uid,
        roomid: roomid,
        enableMic,
      }));
    }

    users.forEach(user => {
      let isSpeak = false;
      const find = members.find(item => item.uid == user.uid);
      if (find && find.isSpeak && !user?.enableMic) isSpeak = true;
      speakUserDom(`.Volumn_${Util.$analyToAccount(user.uid)}_${user.roomid}`, isSpeak? "block" : "none");
    })
  };
  //显示说话成员 - 即构
  that.showSpeakUsersZEGO = (userID, roomID, isSpeak = false) => {
    // 麦位投屏的用户
    const data = that.queueObject?.["SUB_ROOM_MIC_IMAGE"] || null;
    if (data?.micUsers?.length) {
      const micUsers = data.micUsers || [];
      const enableMic = data?.muteEnable || false;
      const isFind = micUsers.find(item => item.uid == userID);
      if (isFind && enableMic) {
        isSpeak = false;
      }
    }

    if (isSpeak) {
      const queueAccount = []
      that.queueList.forEach(queue => queue?.account && queueAccount.push(queue.account))
      speakUserDom(`.Volumn_${Util.$analyToAccount(userID)}_${roomID}`, "block");
    } else {
      speakUserDom(`.Volumn_${Util.$analyToAccount(userID)}_${roomID}`, "none");
    }
    /*const users = [];
    // 麦位的用户
    that.queueList.forEach(item => (item.account && users.push({
      uid: Util.$analyToUid(item.account),
      roomid: that.roomid,
    })));

    // 麦位投屏的用户
    if (that.queueObject?.["SUB_ROOM_MIC_IMAGE"]?.micUsers?.length) {
      const roomid = that.queueObject["SUB_ROOM_MIC_IMAGE"].mainRoomId;
      that.queueObject["SUB_ROOM_MIC_IMAGE"].micUsers.forEach(item => users.push({
        uid: item.uid,
        roomid: roomid,
      }));
    }

    users.forEach(user => {
      const account = Util.$analyToAccount(user.uid);
      if (user.uid == userID && isSpeak) {
        speakUserDom(`.Volumn_${account}_${user.roomid}`, "block");
      } else {
        speakUserDom(`.Volumn_${account}_${user.roomid}`, "none");
      }
    })*/
  };
  function speakUserDom(className, status = "none") {
    if (status !== "none" && status !== "block") return;
    let doms = document.querySelectorAll(className);
    if (doms?.length) {
      for (let i = 0; i < doms.length; i++) {
        const dom = doms[i];
        dom && (dom.style.display = status);
      }
    }
  }
  //重新初始化直播间
  that.reload = (roomid, roomname, callback, joinRoomType = null) => {
    if (that.loading) {
      message.warning('请勿频繁操作');
      return false;
    }
    //房间跳转
    if (roomid == that.roomid && that.conn) {
      message.info('你已经在这个直播间了');
    } else if (that.conn) {
      that.modal && that.modal.destroy();
      that.modal = Modal.confirm({
        title: '提示',
        icon: null,
        closable: true,
        content: roomname
          ? `你确定离开当前直播间前往【${roomname}】吗?`
          : '你确定要跳转到新的直播间吗?',
        className: 'daidai-confirm-style',
        cancelText: '取消',
        okText: '确定',
        centered: true,
        onOk: () => {
          if (!!joinRoomType) {
            Util.setCookie('enter_room_info', joinRoomType);
          }
          if (
            that?.gameInteractData?.pkStatus === 1 &&
            that?.gameInteractData?.roundId
          ) {
            that.events['CHANGE_GAME_INTERACT_GIFT'] &&
              that.events['CHANGE_GAME_INTERACT_GIFT'](false);
          }
          that.room?.disconnect && that.room.disconnect();
          that.reloadExec(roomid || that.roomid);
          callback && callback();
        },
      });
    } else {
      that.reloadExec(roomid || that.roomid);
    }
  };
  //重新进入执行
  that.reloadExec = (roomid) => {
    if (that.webrtc) {
      setTimeout(() => {
        that.reloadExec(roomid);
      }, 500);
      return;
    }
    that.closeLoading();
    //重新初始化直播间
    if (roomid) {
      that.events['INIT_ROOM'] && that.events['INIT_ROOM'](roomid);
    } else {
      that.queueList = [];
      that.queueObject = {};
      that.defaultMsg = [];
      //直播清空
      that.events['CHANGE_LIVE_CONFIG'] && that.events['CHANGE_LIVE_CONFIG']();
      //消息清空
      that.events['CLEAR_ROOM_MESSAGE'] && that.events['CLEAR_ROOM_MESSAGE']();
      //高级礼物动画
      that.events['START_GIFT_USPER_MOVE_DESTROY'] &&
        that.events['START_GIFT_USPER_MOVE_DESTROY']();
      //横幅动画
      that.events['CHANGE_TOP_MESSAGE_DESTROY'] &&
        that.events['CHANGE_TOP_MESSAGE_DESTROY']();
      //普通礼物动画
      that.events['START_GIFT_MOVE_DESTROY'] &&
        that.events['START_GIFT_MOVE_DESTROY']();
      //用户入场动画
      that.events['VIP_MEMBER_ENTER_DESTROY'] &&
        that.events['VIP_MEMBER_ENTER_DESTROY']();
      //喇叭动画
      that.events['TRUMPET_DATA_CHANGE_DESTROY'] &&
        that.events['TRUMPET_DATA_CHANGE_DESTROY']();
      //弹幕动画
      that.events['HIDE_BARRAGE'] && that.events['HIDE_BARRAGE']();
      //弹幕、喇叭数据
      that.events['ROOM_WEALTH_DESTROY'] &&
        that.events['ROOM_WEALTH_DESTROY']();
      //清除空调温度计数据
      that.events['AIRCON_ROOM_TEMP_DESTROY'] &&
        that.events['AIRCON_ROOM_TEMP_DESTROY']();
    }
  };
  //修改我的个人资料
  that.chengMeInfo = (key) => {
    //游客不需要同步
    if (that.isAnonymous()) {
      Util.delCookie('enter_room_info');
      return;
    }
    const enterRoomInfo = Util.readCookie('enter_room_info'); //进房间信息
    let enterRoomType = null; //进房间的类型
    let followUid = null; //被跟随的UID
    if (enterRoomInfo) {
      const info = enterRoomInfo.split('|');
      enterRoomType = info[0] | null;
      followUid = info[1] || null;
    }
    HTTP._get_room_member({
      roomid: that.roomid,
      toUid: that.uid,
      uid: that.uid,
      notifyExt: key,
      enterRoomType,
      followUid,
      ...that.publicParams,
    })
      .then((res) => {
        Util.delCookie('enter_room_info');
        if (res?.code !== 200) {
          if (key === 'memberEnter') {
            message.error('你的资料信息异常, 禁止进入直播间。');
            // that.room.disconnect();
            that.disconnectRoom();
          } else {
            message.error(res.message);
          }
        }
      })
      .catch((err) => {
        Util.delCookie('enter_room_info');
      });
  };
  //加人在线成员列表
  that.joinOnlineMember = (account, user, callback, origin) => {
    if (user) {
      let addCount = 0;
      if (that.onlineMembers[account]) {
        callback && callback(user, true);
      } else {
        that.onlineMembers[account] = account;
        addCount = 1;
        callback && callback(user);
      }
      // 在线列表，需要更新用户信息
      changeOnlineMemberCount(addCount, false, origin);
    } else {
      that.getMemberInfo(account, true, 'joinOnlineMember').then((user) => {
        let addCount = 0;
        if (that.onlineMembers[account]) {
          callback && callback(user, true);
        } else {
          that.onlineMembers[account] = account;
          addCount = 1;
          callback && callback(user);
        }
        // 在线列表，需要更新用户信息
        changeOnlineMemberCount(addCount, false, origin);
      });
    }
  };
  //移除在线成员
  that.delOnlineMember = (account, callback) => {
    if (that.onlineMembers[account]) {
      delete that.onlineMembers[account];
    }
    if (that.memberEnterTimer?.[account]) {
      clearTimeout(that.memberEnterTimer[account])
      delete that.memberEnterTimer[account]
    }
    delete that.members[account];
    changeOnlineMemberCount(-1, false, 'delOnlineMember');
    callback && callback();
  };
  //HTTP方式获取一次用户资料
  that.httpUserCardInfo = function (uid, callback, origin = 'other') {
    if (!that.roomid) return;
    let param = {
      roomid: that.roomid,
      userId: uid,
      uid: that.uid,
    };
    HTTP._get_user_card(param).then((res) => {
      if (res.code == 200 && res.data) {
        callback && callback(res.data);
      } else {
        _anly_seng_custom(1704, { params: param, data: { res, origin } });
      }
    });
  };
  //获取成员信息
  that.getMemberInfo = (account, change, origin) => {
    return new Promise((resolve, reject) => {
      let user = that.members[account];
      if (!that.conn) {
        reject(user);
      } else if (!user || change) {
        // todo 2025.01.24 解决方案 防止频繁调取获取用户信息，使用批量获取的方式
        if (that.getMemberCatchCount == null) that.getMemberCatchCount = 0;
        that.getMemberCatchCount++;
        // 方式频繁获取成员信息导致异常，使用防抖 600ms 后清空计数
        that.getMemberInfoClearTime &&
          clearTimeout(that.getMemberInfoClearTime);
        that.getMemberInfoClearTime = setTimeout(() => {
          that.getMemberCatchCount = 0;
        }, 800);
        const len = that?.getMemberCatchAccounts?.length || 0;
        if (that.getMemberCatchCount > 11) {
          if (len % 6 === 0) {
            // 防止频繁上报
            _anly_seng_custom(1709, {
              data: {
                count: that.getMemberCatchCount || 0,
                len: len,
                origin: origin,
                change: change ? 1 : 0,
                msg: '获取用户信息云信队列异常 - 2',
              },
            });
          }
          that.getMemberCatchFunc(account);
        } else {
          that.room.getChatroomMembersInfo({
            accounts: [account],
            done: (error, obj) => {
              if (error) {
                if (len % 5 === 0) {
                  _anly_seng_custom(1709, {
                    data: {
                      count: that.getMemberCatchCount || 0,
                      error: error,
                      obj: obj,
                      origin: origin,
                      change: change ? 1 : 0,
                      msg: '获取用户信息云信队列异常 - 1',
                    },
                  });
                }
              }
              if (
                error ||
                error == '' ||
                !obj.members ||
                obj.members.length == 0
              ) {
                console.log('云信用户获取失败：', error, obj);
                //游客跳过查询
                if (that.isAnonymous(account)) {
                  reject(error);
                } else {
                  that.httpUserCardInfo(Util.$analyToUid(account), (userinfo) => {
                      let {custom} = userinfo;
                      let newuser = {
                        account: account,
                        avatar: custom.avatar,
                        nick: custom.nickname,
                        online: false,
                        tempMuteDuration: 0,
                        tempMuted: false,
                        type: 'guest',
                        custom,
                      };
                      //存放用户资料
                      that.members[account] = newuser;
                      resolve(newuser);
                    },
                    origin
                  );
                }
              } else {
                user = convertUserInfo({ ...obj.members[0] }, true);
                resolve(user);
              }
            },
          });
        }
      } else {
        if (user?.custom.avator) {
          user.avatar = user.custom.avator;
        }
        resolve(user);
      }
    });
  };
  // todo 2025-01-21 获取成员信息异常时，利用防抖功能避免多次获取失败
  that.getMemberCatchFunc = (account) => {
    if (!that.getMemberCatchAccounts || !that.getMemberCatchAccounts?.length) {
      that.getMemberCatchAccounts = [];
    }
    if (
      Object.prototype.toString.call(that.getMemberCatchAccounts) ===
      '[object Array]'
    ) {
      that.getMemberCatchAccounts.push(account);

      if (that.getMemberCatchAccounts?.length > 18) {
        that.getMemberCatchDebounce.cancel &&
          that.getMemberCatchDebounce.cancel();
        that.getMemberCatchDebounceFunc();
      } else {
        that.getMemberCatchDebounce();
      }
    }
  };
  that.getMemberCatchDebounce = debounce(() => {
    that.getMemberCatchDebounceFunc(() => {
      that.getMemberCatchCount = 0; // 批量获取防抖结束也清空计数
    });
  }, 1000);
  that.getMemberCatchDebounceFunc = (callback = null) => {
    that.getMembersInfo(that.getMemberCatchAccounts, callback);
    that.getMemberCatchAccounts = [];
  };
  // ------- 分割以上内容 --------
  //批量获取成员信息
  that.getMembersInfo = (accounts, callback) => {
    if (!accounts || accounts.length === 0 || !that.conn) {
      callback && callback();
      return;
    }
    that.room.getChatroomMembersInfo({
      accounts: accounts,
      done: (error, obj) => {
        if (error) {
          const count = that.getMemberCatchCount || 0;
          if (count % 3 === 0) {
            _anly_seng_custom(1709, {
              data: {
                count: count,
                error: error,
                obj: obj,
                msg: '获取用户信息云信队列异常 - 3',
              },
            });
          }
        }
        if (obj && obj.members) {
          obj.members.forEach((member) => {
            convertUserInfo({ ...member }, true);
          });
        }
        callback && callback(obj.members);
      },
    });
  };
  //获取全局base
  that.getBase = function () {
    that.base = store.getState();
    that.publicParams = {
      client: that.base.client,
      webVersion: that.base.rootConfig.version,
      pcVersion: that.base.clientInfo.version,
    };
    return that.base;
  };
  //获取当前房间模板
  that.getRoomRmode = function () {
    let mode = 0;
    if (that.roomInfo && that.roomInfo.custom) {
      mode = that.roomInfo.custom.rmode || 0;
    }
    return mode;
  };
  //是否是游客登录
  that.isAnonymous = function (uid) {
    if (!uid) {
      return that.account.indexOf('nimanon') != -1;
    }
    uid = uid.toString();
    if (uid) {
      return uid.indexOf('nimanon') != -1;
    }
    if (uid && uid.length > 11) {
      return true;
    }
    if (
      that.account == false ||
      that.account == undefined ||
      that.account == 'undefined'
    ) {
      return true;
    }
    return that.account.indexOf('nimanon') != -1;
  };
  //是否存在直播
  that.hasLive = function () {
    return (
      that.queueList &&
      that.queueList.length > 0 &&
      that.liveConfig &&
      that.liveConfig != ''
    );
  };
  //我当前是否在互动列表
  that.hasQueume = function (account) {
    if (account) {
      return that.queueObject[account];
    }
    return that.queueObject[that.account];
  };
  //我是否是当前主持人
  that.isMaster = function (account) {
    if (!that.hasLive()) return false;
    if (account) {
      let mm = that.queueObject[account];
      return mm && mm.index == 0;
    }
    let mm = that.queueObject[that.account];
    return mm && mm.index == 0;
  };
  //获取主持人
  that.getMaster = function () {
    if (!that.hasLive()) return null;
    if (!that.queueList || !that.queueList.filter) return null;
    let mas = that.queueList.filter((item) => item.index == 0);
    if (mas.length > 0) return mas[0].account;
    return null;
  };
  //当前是否有主持人
  that.hasMaster = function () {
    let master = false;
    that.queueList.forEach((item) => {
      if (item.index == 0) master = true;
    });
    return master;
  };
  //是否可以大更新
  that.isLoading = function () {
    if (that.loading) return true;
    that.loading = message.loading('执行中...', 0);
    return false;
  };
  //关闭限制
  that.closeLoading = function () {
    if (that.loading) message.destroy();
    that.loading = null;
  };
  //当前设备是否是PC
  that.isPC = function () {
    const { client } = that.getBase();
    return client == 'PC';
  };
  //当前设备是否是ELE UELE
  that.isELE = function () {
    const { client } = that.getBase();
    return client == 'ELE' || client == 'UELE';
  };
  //我当前是否申请了排麦
  that.hasLine = function (account) {
    if (!account) {
      account = that.account;
    }
    if (!that.queueLine) return null;
    if (!that.queueLine || !that.queueLine.filter) return null;
    let arr = that.queueLine.filter((item) => item.account == account);
    if (arr && arr.length > 0 && arr[0].state != 2) {
      return arr[0];
    }
    return null;
  };
  //静音
  that.changeVolume = function () {
    that.volume = that.volume == 1 ? 0 : 1;
    that.events['CHANGE_LIVE_VOLUME'] && that.events['CHANGE_LIVE_VOLUME']();
  };
  // 麦克风控制
  that.changeMicAudioStatus = ({
    account,
    isDisAudio,
    isSelfDisAudio: yxIsSelfDisAudio,
    isMasterDisAudio: yxIsMasterDisAudio,
    isGameOperate,
    callback,
  }) => {
    let curDisAudio = isDisAudio;
    const queuser = that.hasQueume(account);
    if (isDisAudio == null) {
      curDisAudio = !queuser.disAudio;
    }
    if (isGameOperate) {
      // 游戏控制麦位变化, 用于同步麦位麦克风状态
      let queue_me = that.queueObject[that.me.account];
      if (queue_me) {
        const isDiff = queue_me.disAudio !== curDisAudio;
        isDiff &&
          changeMeMicState({
            disAudio: curDisAudio,
            isSync: true,
            isGameOperate: true,
          });
      }
    } else {
      const { microType } = that.getBase();

      if (microType === 0) {
        that.sendCustomMsg({
          action: '5-2',
          account,
          disAudio: curDisAudio,
          isMasterDisAudio: yxIsMasterDisAudio,
          isSelfDisAudio: yxIsSelfDisAudio,
          isSync: true,
        });

        callback && callback(curDisAudio);
      } else {
        HTTP._post_server_change_mic({
          disAudio: curDisAudio,
          index: queuser.index,
          toUid: Util.$analyToUid(queuser.account),
          uid: that.uid,
        })
          .then((res) => {
            if (res?.code === 200) {
              that.sendCustomMsg({
                action: '5-2',
                account,
                disAudio: curDisAudio,
                isMasterDisAudio: yxIsMasterDisAudio,
                isSelfDisAudio: yxIsSelfDisAudio,
                isSync: false,
              });
              callback && callback(curDisAudio);
            } else {
              message.warning(res?.message || '操作失败，请稍后重试');
            }
          })
          .catch((err) => {
            message.warning('操作失败，请稍后重试');
          });
      }
    }
  };
  //当前入驻房间
  that.getNowConRoom = function () {
    if (that.conn && that.roomid) return that.roomid;
    return null;
  };
  //我要上麦
  that.onUpmic = function (index, confirm, callback = null) {
    if (Date.now() - that.createTime < 2000) {
      message.info('数据处理中, 请稍后~', 1);
      return false;
    }
    //游客申请
    if (that.isAnonymous()) {
      _show_login_modal();
      return false;
    }
    //禁言不允许上麦
    if (that.me && that.me.tempMuted) {
      message.info('你已被禁言, 无法申请上麦。');
      return false;
    }
    //禁止直接更换主持
    let hasMeQue = that.hasQueume();
    if (hasMeQue && index == 0) {
      message.info('禁止直接切换到主持麦~', 1);
      return false;
    }
    //主持位申请
    if (index == 0) {
      const { microType } = that.getBase();
      if (microType === 0) {
        if (that.me.custom && that.me.custom.roleId) {
          if (that.isLoading()) return false;
          //验证是否有主持权限
          HTTP._operation_room_role({
            operationFromId: that.me.account,
            operationType: 1,
            roomId: that.roomid,
            fromUserId: that.uid,
            ...that.publicParams,
          }).then((res) => {
            if (res?.code === 200) {
              that.onUpmicRTC(index);
              callback && callback(true);
            } else {
              that.closeLoading();
              message.warning(res?.message ?? '你没有开启直播的权限');
              callback && callback(false);
            }
          });
        } else {
          message.warning('你没有开启直播的权限');
          callback && callback(false);
        }
      } else {
        that.onUpmicRTC(index, callback);
      }
    }
    //申请排麦
    else {
      that.events['CHANGE_LIVEON_QUEUE'] &&
        that.events['CHANGE_LIVEON_QUEUE'](that.me, index, confirm);
    }
  };
  //执行上麦 callback 服务端上麦回调所用
  that.onUpmicRTC = (index, callback = null) => {
    //额外添加一次规则拦截 - 未知终端异常
    if (index < 0) {
      message.warning('麦位已不存在');
      return false;
    }
    //切换麦位
    if (that.webrtc) {
      const { microType, isMasterDisAudio, isSelfDisAudio } = that.getBase();
      if (microType === 0) {
        if (that.hasQueume()) {
          that.queueOffer(that.me.account, {
            ...that.queueObject[that.me.account],
            index: index,
          });
        } else {
          const { client, rootConfig, clientInfo } = that.getBase();
          that.queueOffer(that.me.account, {
            index: index, //主播位
            volumn: 0, //麦克风音量
            nick: that.me.nick, //昵称
            microphone: true, //开启麦克风
            disAudio: !that.webrtc.mic_state || false, //是否静音
            account: that.me.account, //帐号
            master_type: client, //主播当前终端类型
            web_version: rootConfig.version, //网页独有版本参数
            pc_version: clientInfo.version, //pc独有版本参数
          });
        }
      } else {
        // 服务端上麦
        HTTP._post_server_up_microphone({
          roomId: that.roomid,
          index,
          disAudio: !that.webrtc.mic_state || false,
          microphone: true,
          operationType: 0,
        })
          .then((res) => {
            if (res?.code !== 200) {
              message.warning(res?.message || '操作失败，请稍后重试~');
              callback && callback(false);
            } else {
              callback && callback(true);
            }
          })
          .catch((err) => {
            message.warning('操作失败，请稍后重试~');
            callback && callback(false);
          });
      }

      store.dispatch({
        type: 'set_is_master_dis_audio',
        data: { isMasterDisAudio, isSelfDisAudio },
      });
    } else if (that.me.gaged) {
      that.closeLoading();
      message.error('你已被禁言, 无法上麦');
    } else {
      that.closeLoading();
      message.warning('操作失败，请刷新页面后重试');
    }
  };
  //删除麦位队列元素
  that.queuePoll = (key, callback) => {
    if (that.isAnonymous()) return;
    that.room.queuePoll({
      elementKey: key,
      done: function (err, obj) {
        console.warn('==queuePoll==', key, obj, err);
        if (!!err && that.queueObject[key]) {
          // 云信队列不存在或删除失败，则手动移除缓存数据
          delete that.queueObject[key];
        }
        if (
          !!err &&
          !(key.indexOf('queue_') > -1 && err?.code === 404) &&
          key.indexOf(that.uid) === -1
        ) {
          _anly_seng_custom(1508, {
            data: { uid: that.uid, key, err: err.toString() },
          });
        }
        callback && callback(obj);
      },
    });
  };
  //添加聊天室队列
  that.queueOffer = (key, value, callback, notTransient) => {
    if (that.isAnonymous()) return;
    that.room.queueOffer({
      elementKey: key,
      elementValue: JSON.stringify(value),
      transient: !notTransient,
      done: function (err, obj) {
        console.warn('queueOffer', key, obj, err);
        callback && callback(obj);
        //当完成了上麦 就必须移除原有的申请队列。 不然会有异常
        let queObj = that.queueObject[`queue_${that.uid}`];
        if (!err && queObj) {
          that.queuePoll(`queue_${that.uid}`);
        } else if (err?.code === 414) {
          message.warning('上麦异常，请重新进入房间');
        }
        if (err?.code != null) {
          console.error('=====queueOffer=====', err, obj);
        }
      },
    });
  };
  //保存直播扩展配置
  that.modifyConfig = function (r, needNotify, callback) {
    HTTP._modify_room_ext({
      uid: that.uid,
      roomid: that.roomid,
      roomcid: r.channelId || that.liveConfig.channelId,
      needNotify: needNotify || false,
      data: typeof r == 'string' ? r : JSON.stringify(r),
    }).then((res) => {
      if (res.code != 200) {
        message.error(res.message);
      }
      callback && callback();
    });
  };
  function isSendContent() {
    const { rootConfig, userInfo } = that.getBase();
    if (!userInfo) {
      _show_login_modal();
      return false;
    }
    //强制必须绑定手机
    if (
      (!userInfo.bindPhone || userInfo.bindPhone == '') &&
      rootConfig.lang == 'zh_CN'
    ) {
      _change_phone_modal(true);
      return false;
    }
    //如果我被禁言 就禁止发送
    if (that.me?.type == 'restricted' || that.me?.tempMuted) {
      message.warning('你已被禁言, 无法发送。');
      return false;
    }
    return true;
  }
  //发送自定义消息
  that.sendCustomMsg = function (content) {
    const { rootConfig } = that.getBase();
    if (!isSendContent()) return;
    if (!that.conn) return;
    that.room.sendCustomMsg({
      content: JSON.stringify(content),
      done: function (error, obj) {
        if (error) {
          if (error.code && rootConfig.errorCode[error.code]) {
            message.error(`${rootConfig.errorCode[error.code]}`);
          } else {
            message.error(error.message);
          }
        } else {
          onmsg(obj);
          //公屏消息上报
          _dssp_send_click(86, {
            uid: that.uid,
            room_id: that.roomid,
            type: 1,
          });
        }
      },
    });
  };
  //发送普通文本消息
  that.sendText = async function (text, msgType) {
    const { rootConfig, uid, token, barrageIndex } = that.getBase();
    if (!isSendContent()) return;
    if (!that.conn) return;
    //普通
    if (msgType == 1) {
      const custom = { room_id: that.roomid };
      /* 大数据上报所需字段 */
      if (window?.century_setting?.os_type != null)
        custom.os_type = window.century_setting.os_type;
      const uuid = await Util.getReportUuid();
      if (uuid) custom.uuid = uuid;
      //普通消息
      that.room.sendText({
        text: text,
        custom,
        done: function (error, obj) {
          if (error) {
            if (error.code && rootConfig.errorCode[error.code]) {
              message.error(`${rootConfig.errorCode[error.code]}`);
            } else {
              message.error(error.message);
            }
          } else {
            onmsg(obj);
            //公屏消息上报
            _dssp_send_click(86, {
              uid: that.uid,
              room_id: that.roomid,
            });
          }
        },
      });
    }
    //喇叭消息
    else if (msgType == 2) {
      if (text.length > 20) {
        message.error('喇叭最多可输入20个字符');
        return;
      }
      let val = encodeURIComponent(text);
      HTTP._trumpetSend({
        uid: uid,
        content: val,
        roomid: that.roomid,
        hostId: '',
      }).then((res) => {
        if (res.code == 200) {
          //更新余额
          _get_user_info({ qKey: 'WebRoom1' });
          that.events['HORN_SUCCESS'] && that.events['HORN_SUCCESS']();
        } else {
          //绑定手机
          if (res.code == 3) {
            _change_phone_modal(true);
          } else if (res.code == 2) {
            //余额不足
            that.events['NOT_ENOUGH_MONEY'] &&
              that.events['NOT_ENOUGH_MONEY']();
            message.warning('钻石余额不足，请充值后再发送');
          } else {
            message.error(res.message);
          }
        }
      });
    }
    //弹幕消息
    else if (msgType == 3) {
      if (text.length > 20) {
        message.error('弹幕最多可输入20个字符');
        return;
      }
      if (!barrageIndex) {
        //没有主动选择弹幕类型
        return;
      }
      let val = encodeURIComponent(text);
      HTTP._barrageSend({
        uid: uid,
        token: token,
        content: val,
        barrageId: barrageIndex,
        roomid: that.roomid,
      }).then((res) => {
        if (res.code == 200) {
          //更新余额
          _get_user_info({ qKey: 'WebRoom1' });
          that.events['BARRAGE_SUCCESS'] &&
            that.events['BARRAGE_SUCCESS'](res.data);
        } else {
          //绑定手机
          if (res.code == 3) {
            _change_phone_modal(true);
          } else if (res.code == 4) {
            //弹幕数量不足，购买弹幕数量
            that.events['NOT_ENOUGH_MONEY_AND_SHOW_BUY'] &&
              that.events['NOT_ENOUGH_MONEY_AND_SHOW_BUY'](true);
            message.warning(
              res ? res.message : '弹幕数量不足，请购买弹幕数量后再发送'
            );
          } else {
            message.error(res.message);
          }
        }
      });
    }
  };
  //动画权限设置
  that.changeShieldMove = function (reset) {
    that.shieldMove = {
      DisGiftMove: Util.readCookie('DisGiftMove'), //礼物动画
      DisRoomEnter: Util.readCookie('DisRoomEnter'), //用户入场
      DisRoomBullet: Util.readCookie('DisRoomBullet'), //弹幕
      DisRoomStreamer: Util.readCookie('DisRoomStreamer'), //横幅
      DisRoomBroadcast: Util.readCookie('DisRoomBroadcast'), //广播
      DisUpdateBroadcast: Util.readCookie('DisUpdateBroadcast'), //升级
      DisRoomEffects: Util.readCookie('DisRoomEffects'), // 房间特效，只有点唱模板才会有 todo 2.26.0
    };
    if (reset && that.shieldMove.DisGiftMove) {
      //高级礼物动画
      that.events['START_GIFT_USPER_MOVE_DESTROY'] &&
        that.events['START_GIFT_USPER_MOVE_DESTROY']();
      //普通礼物动画
      that.events['START_GIFT_MOVE_DESTROY'] &&
        that.events['START_GIFT_MOVE_DESTROY']();
      //用户入场动画
      that.events['VIP_MEMBER_ENTER_DESTROY'] &&
        that.events['VIP_MEMBER_ENTER_DESTROY']();
      //喇叭动画
      that.events['TRUMPET_DATA_CHANGE_DESTROY'] &&
        that.events['TRUMPET_DATA_CHANGE_DESTROY']();
      //横幅动画
      that.events['CHANGE_TOP_MESSAGE_DESTROY'] &&
        that.events['CHANGE_TOP_MESSAGE_DESTROY']();
      //弹幕动画
      that.events['HIDE_BARRAGE'] && that.events['HIDE_BARRAGE']();
      // 房间特效
      that.events['CHANGE_ROOM_EFFECTS_DESTROY'] &&
        that.events['CHANGE_ROOM_EFFECTS_DESTROY']();
    }
  };
  //暴露销毁直播间方法
  that.disconnectRoom = function () {
    return new Promise((resolve) => {
      disconnect();
      setTimeout(resolve, 1000);
    });
  };
  // 退出房间清除相关的数据结构
  that.clearRoomData = function () {
    that.isInRoom = false;
    that.isAnonymousRoom = false;
    that.onlineMembers = {};
    that.onlineMemberCount = 0;
    that.members = {};
    that.defaultMsg = [];
    that.queueList = [];
    that.queueObject = {};
    that.queueLine = [];

    clearTimeout(that.addCustomTimer);
  };
  return that;
})();

export default WEBROOM;
